//Paquetes NPM de GYF. 
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, RestApiProxy, RabbitListener, SagasProxy, ConciergeProxy, SagasHelper } from 'com-gyf-webcore-servicehub';

//Import del reducer de DistribucionLimites.
import distribucionLimitesReducer from '../../../store/Reducers/DistribucionLimites';

import SolicitudManager from '../../../Common/Managers/SolicitudManager';
import ProcessManager from "../../../Common/Managers/ProcessManager";


//Seteo de apiUrl
RestApiProxy.SetApiUrl();

// ACTION TYPES
export const SHOW_SAVE_STATUS_NUEVA_SOLICITUD_CUENTA = "SHOW_SAVE_STATUS_NUEVA_SOLICITUD_CUENTA";
export const GUARDAR_SOLICITUD_BORRADOR_NUEVA_SOLICITUD_CUENTA = "GUARDAR_SOLICITUD_BORRADOR_NUEVA_SOLICITUD_CUENTA";
export const GET_SCREEN_DATA_CUENTA = "GET_SCREEN_DATA_CUENTA";
export const SHOW_ERROR_CUENTA = "SHOW_ERROR";
export const GET_DATA_ACCOUNT = "GET_DATA_ACCOUNT";
export const OPEN_MODAL_DISTRIBUIRLIMITES_CUENTA = "OPEN_MODAL_DISTRIBUIRLIMITES_CUENTA";
export const CLOSE_MODAL_DISTRIBUIRLIMITES_CUENTA = "CLOSE_MODAL_DISTRIBUIRLIMITES_CUENTA";
export const ROUTE_TO_TARJETAS_FROM_CUENTA = "ROUTE_TO_TARJETAS_FROM_CUENTA";
export const ROUTE_TO_NUEVA_CUENTA = "ROUTE_TO_NUEVA_CUENTA";
export const SELECT_CUENTA = "SELECT_CUENTA";
export const RESET_STATE_CUENTA = "SELECT_ACCOUNT";
export const ACTUALIZAR_LIMITES_CUENTA = 'ACTUALIZAR_LIMITES_CUENTA';
export const ACTUALIZAR_ESTADO_GLOBAL_CUENTA = "ACTUALIZAR_ESTADO_GLOBAL_CUENTA";
export const ROUTE_TO_VISTACLIENTE_FROM_CUENTA = "ROUTE_TO_VISTACLIENTE_FROM_CUENTA";
export const ROUTE_TO_TIPOEMPRESA_FROM_CUENTA = "ROUTE_TO_TIPOEMPRESA_FROM_CUENTA";
export const ACTUALIZAR_ESTADO_DISTRIBUCION_CUENTA = 'ACTUALIZAR_ESTADO_DISTRIBUCION_CUENTA';
export const ELIMINAR_FUTURO_FROM_CUENTA = 'ELIMINAR_FUTURO_FROM_CUENTA';
export const GET_DATA_SOLICITUD_RESULT = 'GET_DATA_SOLICITUD_RESULT';
export const SELECT_COMBO_N_S_CUENTA = 'SELECT_COMBO_N_S_CUENTA';
export const SELECT_INPUT_N_S_CUENTA = 'SELECT_INPUT_N_S_CUENTA';
export const ON_BLUR_TEXTBOX = 'ON_BLUR_TEXTBOX';
export const SELECCIONAR_PROMOTOR = 'SELECCIONAR_PROMOTOR';
export const MONEDA_TYPE_CHANGE = 'MONEDA_TYPE_CHANGE';
export const READY_REQUEST_CUENTA = 'READY_REQUEST_CUENTA';
export const VALIDATE_CUENTA_ERROR_CUENTA = 'VALIDATE_CUENTA_ERROR_CUENTA';
export const CORRESPONDENCIA_TYPE_CHANGE = 'CORRESPONDENCIA_TYPE_CHANGE';
export const SELECT_CHECKBOX_N_S_CUENTA = 'SELECT_CHECKBOX_N_S_CUENTA';
export const CHANGE_INPUT_N_S_CUENTA = 'CHANGE_INPUT_N_S_CUENTA';
export const SAVE_SOLICITUD_CUENTA_SELECCION = 'SAVE_SOLICITUD_CUENTA_SELECCION';
export const ESCONDER_POPUP_SOLICITUD = 'ESCONDER_POPUP_SOLICITUD';
export const NUEVA_SOLICITUD_CUENTA_SUCCED = 'NUEVA_SOLICITUD_CUENTA_SUCCED';
export const SET_REDIRECT_VISTA_CLIENTE = 'SET_REDIRECT_VISTA_CLIENTE';
export const LOAD_MODIFICACION_SOLICITUD_TARJETAS = 'LOAD_MODIFICACION_SOLICITUD_TARJETAS';
export const LOAD_MODIFICACION_SOLICITUD = 'LOAD_MODIFICACION_SOLICITUD';
export const LOAD_DATA_TARJETAS = 'LOAD_DATA_TARJETAS';
export const FLAG_DATOS_MODIFICACION_CARGADOS = 'FLAG_DATOS_MODIFICACION_CARGADOS';
export const FOUND_CLIENTE_LISTA_DOCUMENTOS = 'FOUND_CLIENTE_LISTA_DOCUMENTOS';
export const NOT_FOUND_CLIENTE_LISTA_DOCUMENTOS = 'NOT_FOUND_CLIENTE_LISTA_DOCUMENTOS';
export const VOLVER_A_SOLICITUD_NSC = 'VOLVER_A_SOLICITUD_NSC';
export const ROUTE_TO_CUENTADATOS_FROM_ADICIONAL = 'ROUTE_TO_CUENTADATOS_FROM_ADICIONAL';
export const RETRIEVING_DATA = 'RETRIEVING_DATA';
export const BACK_FROM_ADICIONALES = 'BACK_FROM_ADICIONALES'
export const GET_PRODUCTOS_BY_SUCURSAL = 'GET_PRODUCTOS_BY_SUCURSAL';
export const CARGAR_DATOS_MODIFICACION = 'CARGAR_DATOS_MODIFICACION';
export const CARGAR_DATOS_MODIFICACION_TARJETAS = 'CARGAR_DATOS_MODIFICACION_TARJETAS';
export const CARGAR_ADICIONALES_MODIFICACION = 'CARGAR_ADICIONALES_MODIFICACION';
export const CARGAR_CLIENTE_PARA_TARJETA = 'CARGAR_CLIENTE_PARA_TARJETA';
export const CONFIRMAR_CLIENTE_PARA_TARJETA = 'CONFIRMAR_CLIENTE_PARA_TARJETA';
export const SELECT_DOMICILIO_VISA = 'SELECT_DOMICILIO_VISA';
export const NOT_FOUND_CLIENTE = 'NOT_FOUND_CLIENTE';
export const ACTUALIZAR_ESTADO_CLIENTE = 'ACTUALIZAR_ESTADO_CLIENTE';
export const BUSCANDO_CODIGO_GEOGRAFICO = 'BUSCANDO_CODIGO_GEOGRAFICO';
export const CARGAR_ADICIONALES_MODIFICACION_NSC = 'CARGAR_ADICIONALES_MODIFICACION_NSC';

/*variables a validar*/
let _dispatch, _tarjetas, _tipoEmpresa, _NuevaSolicitudCuentaData = null;
let userFeatures = [];
let _executionContext;

/**
 *
 * @param {any} solicitud
 */
/*export function guardarSolicitudBorrador() {
    LogHelper.In(guardarSolicitudBorrador.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        let promise = new Promise((resolve) => {
            resolve(() => {
                //TODO: MAL, ESTA SETEANDO Y PUEDE HABER INCONSISTENCIA.
                let cuentas = getState().nuevaSolicitudCuenta.cuentas;
                dispatch({ type: ACTUALIZAR_ESTADO_GLOBAL_CUENTA, cuentas });
            });
        });

        promise.then(() => {
            SolicitudManager.GuardarSolicitudBorrador(_tarjetas, (data) => guardarSolicitudBorradorCallback(data, dispatch));
        });
    }
}
*/
/**
 * 
 * @param {any} currentScope
 */
export function cargarDatosPantalla(currentScope) {
    LogHelper.In(cargarDatosPantalla.name, currentScope);

    return (dispatch, getState) => {        
        _tarjetas = JSON.parse(JSON.stringify(getState().tarjetas));
        _NuevaSolicitudCuentaData = JSON.parse(JSON.stringify(getState().nuevaSolicitudCuenta));
        _dispatch = dispatch;
        _executionContext = JSON.parse(JSON.stringify(getState().sesion.executionContext));

        var currentScopeRequest = {
            "UserId": currentScope.UserId,
            "ProductCode": currentScope.ProductCode,
            "ProgramCode": currentScope.ProgramCode
        }
        
        ConciergeProxy.Execute((data) => _cargarDatosPantalla(data), null, "GETFUNCTIONS", currentScopeRequest);
    }
}

/**
 * SELECCIONA OPCIÓN DE COMBO
 * @param {any} action
 * @param {any} id
 */
export function selectCombo(action, id) {
    LogHelper.In(selectCombo.name, action, id);
        
    return (dispatch) => {
        dispatch({ type: SELECT_COMBO_N_S_CUENTA, action: action, id: id });
        dispatch({ type: SAVE_SOLICITUD_CUENTA_SELECCION, prop: action, value: id });
    }
}


/**
 * MANEJA EL FLAG QUE INDICA SI SE ESTÁ VOLVIENDO DE ADICIONALES PARA LA CARGA DE DATOS QUE PERSISTIERON EN TARJETAS
 */

export function backAdicionales() {
    LogHelper.In(backAdicionales.name);
    
    return (dispatch) => {
        dispatch({ type: BACK_FROM_ADICIONALES});
    }
}

/**
 * ACTION DE SELECCIÓN DE CHECKBOX, ACTION ES EL CAMPO
 */

export function selectCheckBox(action){
    LogHelper.In(selectCheckBox.name, action);
    return (dispatch,getState) => {

        let st = getState();
        let value = !st.nuevaSolicitudCuenta[action]

        dispatch({ type: SELECT_CHECKBOX_N_S_CUENTA, action: action }); //agregar seleccion a tarjeta
        dispatch({ type: SAVE_SOLICITUD_CUENTA_SELECCION, prop: action, value: value });
    }
}


export function seleccionarPromotor(promotor) {
    LogHelper.In(seleccionarPromotor.name, promotor);
    return (dispatch) => {
        dispatch({ type: SELECCIONAR_PROMOTOR, promotor });
        dispatch({ type: SAVE_SOLICITUD_CUENTA_SELECCION, prop: "promotorSeleccionado", value: promotor });
    }
}


//action que trae los códigos geográficos de acuerdo al código postal del domicilio seleccionado
export function selectDomicilioVisa(domicilio,tipo) {
    LogHelper.In(selectDomicilioVisa.name, domicilio,tipo);

    let param={
        'CODIGO_POSTAL':domicilio.CodigoPostal
    }
    
    return (dispatch)=>{
        dispatch({ type: BUSCANDO_CODIGO_GEOGRAFICO, payload:true });
        LogHelper.Out(selectDomicilioVisa.name, param, 'GET_CODIGO_GEOGRAFICO_VISA', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_CODIGO_GEOGRAFICO_VISA', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');               
            
        Engine1Proxy.Execute((data) => _selectDomicilioVisaCallBack(data,domicilio,dispatch,tipo), null, null, "SOLICITUD"); 
    }
    
}

/**
 * ACTION QUE LLENA LOS CAMPOS QUE REQUIEREN INPUTS DE TEXTO, ACTION ES EL CAMPO
 */
export function onBlurTextBox(action, value) {
    LogHelper.In(onBlurTextBox.name, action, value);

    return (dispatch) => {
        dispatch({ type: ON_BLUR_TEXTBOX, action: action, value: value });
        dispatch({ type: SAVE_SOLICITUD_CUENTA_SELECCION, prop: action, value: value });
    }
}

export function selectInput(action, valor) {
    // SE CREA FUNCION SEPARADA PARA REALIZAR VALIDACIONES CUANDO CORRESPONDA
    LogHelper.In(selectInput.name, action, valor);
    return (dispatch) => {
        dispatch({ type: SELECT_INPUT_N_S_CUENTA, action: action, valor: valor });
    }
}


/**
 * ACTION PARA LA SELECCIÓN DE MONEDA DE LOS LIMITES TIPO "M"
 */
export function radioMonedaSelected(value) {
    LogHelper.In(radioMonedaSelected.name, value);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: MONEDA_TYPE_CHANGE, value });
        dispatch({ type: SAVE_SOLICITUD_CUENTA_SELECCION, prop: "moneda", value: value });
    }
}

/**
 * ACTION QUE SELECCIONA EL MODO DE CORRESPONDENCIA EN LOS RADIOS DE NUEVA SOLICITUD CUENTA
 */

export function correspondenciaModo(value) {
    LogHelper.In(correspondenciaModo.name, value);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: CORRESPONDENCIA_TYPE_CHANGE, value });
        dispatch({ type: SAVE_SOLICITUD_CUENTA_SELECCION, prop: "correspondencia", value: value });
    }
}

export function changeInput(action, value) {
    LogHelper.In(changeInput.name, action, value);

    return (dispatch) => {
        dispatch({ type: CHANGE_INPUT_N_S_CUENTA, action: action, value: value });
        dispatch({ type: SAVE_SOLICITUD_CUENTA_SELECCION, prop: action, value: value });
    }
}

/**
 *
 */
export function routeToVistaCliente() {
    LogHelper.In(routeToVistaCliente.name);

    return (dispatch, getState) => {
        dispatch({ type: ROUTE_TO_VISTACLIENTE_FROM_CUENTA });
    }
}

/**
 *
 */
export function routeToNuevaSolicitudTipoEmpresa() {
    LogHelper.In(routeToNuevaSolicitudTipoEmpresa.name);

    return (dispatch, getState) => {
        dispatch({ type: ROUTE_TO_TIPOEMPRESA_FROM_CUENTA });
    }
}

export function reiniciarStateCuenta() {
    LogHelper.In(reiniciarStateCuenta.name);

    return (dispatch, getState) => {
        let cuentas = getState().nuevaSolicitudCuenta.cuentas;
        dispatch({ type: RESET_STATE_CUENTA });
    }
}

/**
 * FUNCIÓN QUE SELECCIONA SUCURSAL Y EN BASE A ESTA TRAE LOS PRODUCTOS CORRESPONDIENTES
 * @param {*} idSucursal 
 */

export function selectSucursal(idSucursal){
    LogHelper.In(selectSucursal.name, idSucursal);

    return (dispatch, getState) => {
        
        _tarjetas = getState().tarjetas;
        
        let admin = _tarjetas.administradora.Id ? _tarjetas.administradora.Id : _tarjetas.administradora;
        let cuentaTipo = _tarjetas.tipoEmpresa.Id ? _tarjetas.tipoEmpresa.Id : _tarjetas.tipoEmpresa;          
        let param = {
            'ADMINISTRADORA_ID': admin,
            'CUENTA_TIPO_ID': cuentaTipo,
            'SUCURSAL_ID': idSucursal
        };
        
        
        if (admin == 1) {
            LogHelper.Out(selectSucursal.name, param, 'GET_PRODUCTOS_BY_SUCURSAL_VISA', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(param, 'GET_PRODUCTOS_BY_SUCURSAL_VISA', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
            
        } else if (admin == 2) {
            LogHelper.Out(selectSucursal.name, param, 'GET_PRODUCTOS_BY_SUCURSAL_CABAL', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(param, 'GET_PRODUCTOS_BY_SUCURSAL_CABAL', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');             
        }
        
        

        Engine1Proxy.Execute((data) => _selectSucursalCallBack(data, admin), null, null, "SOLICITUD"); 
    }
}

/**
 * Funcion utilizada para recargar los datos de la pantalla de solicitud de cuenta cuando se cambia el producto seleccionado
 * @param {any} productoId
 */
export function productoSelected(productoId) {
    LogHelper.In(productoSelected.name, productoId);
    
    return (dispatch, getState) => {

        
        _tarjetas = getState().tarjetas;
        let admin = _tarjetas.administradora.Id ? _tarjetas.administradora.Id : _tarjetas.administradora;
        let cuentaTipo = _tarjetas.tipoEmpresa.Id ? _tarjetas.tipoEmpresa.Id : _tarjetas.tipoEmpresa;          
        let param = {
            'PRODUCTO_ID': productoId,
            'ADMINISTRADORA_ID': admin,
            'EMPRESA_ID': !_tarjetas.clienteResultadoBusqueda.esPersonaFisica ? _tarjetas.clienteResultadoBusqueda.Id : null,
            'CLIENTE_ID': _tarjetas.clienteResultadoBusqueda.esPersonaFisica ? _tarjetas.clienteResultadoBusqueda.Id : null,
            'CUENTA_TIPO_ID': cuentaTipo,
            'MARCA': admin == 1 ? 'VISA' : 'CABAL'
        };

        let parametro = {
            'CODIGO_EQUIVALENCIA': 'CORE'
        };
        
        if (admin == 1) {
            LogHelper.Out(productoSelected.name, param, 'GET_PRODUCTO_VISA_PRODUCTO_ID', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(param, 'GET_PRODUCTO_VISA_PRODUCTO_ID', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
            
            LogHelper.Out(productoSelected.name, param, 'GET_PRODUCTO_DEFAULT_VISA_PRODUCTO', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(param, 'GET_PRODUCTO_DEFAULT_VISA_PRODUCTO', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
            
            LogHelper.Out(productoSelected.name, param, 'GET_CARTERAS_EMPRESA', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(param, 'GET_CARTERAS_EMPRESA', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
            
            LogHelper.Out(productoSelected.name, param, 'GET_CODIGO_DISTRIBUCION_BY_PRODUCTO_ID', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(param, 'GET_CODIGO_DISTRIBUCION_BY_PRODUCTO_ID', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');

            LogHelper.Out(productoSelected.name, param, 'GET_COMERCIALIZADORA_CANAL_VENTA_BY_PRODUCTO', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(param, 'GET_COMERCIALIZADORA_CANAL_VENTA_BY_PRODUCTO', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
            
            LogHelper.Out(productoSelected.name, param, 'GET_SUCURSAL_CLIENTE_CUENTA', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(param, 'GET_SUCURSAL_CLIENTE_CUENTA', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        } else if (admin == 2) {
            LogHelper.Out(productoSelected.name, param, 'GET_SUCURSAL_CLIENTE_CUENTA_CABAL', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(param, 'GET_SUCURSAL_CLIENTE_CUENTA_CABAL', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
            
            LogHelper.Out(productoSelected.name, param, 'GET_PRODUCTO_CABAL_PRODUCTO_ID', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(param, 'GET_PRODUCTO_CABAL_PRODUCTO_ID', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
            
            LogHelper.Out(productoSelected.name, param, 'GET_PRODUCTO_DEFAULT_CABAL_PRODUCTO', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(param, 'GET_PRODUCTO_DEFAULT_CABAL_PRODUCTO', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
            
            LogHelper.Out(productoSelected.name, param, 'GET_SEGMENTO_CARTERA_PRODUCTO_ID', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(param, 'GET_SEGMENTO_CARTERA_PRODUCTO_ID', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
            
            LogHelper.Out(productoSelected.name, param, 'GET_MARCA_COMPARTIDA_PRODUCTO_ID', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(param, 'GET_MARCA_COMPARTIDA_PRODUCTO_ID', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
            
        }
        
        LogHelper.Out(productoSelected.name, param, 'GET_GRUPOS_AFINIDAD_BY_PRODUCTO', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_GRUPOS_AFINIDAD_BY_PRODUCTO', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        
        LogHelper.Out(productoSelected.name, param, 'GET_MODALIDAD_DISTRIBUCION_LIMITE_PRODUCTO_ID', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_MODALIDAD_DISTRIBUCION_LIMITE_PRODUCTO_ID', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        
        LogHelper.Out(productoSelected.name, param, 'GET_LIMITE_COMPRA_PRODUCTO', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_LIMITE_COMPRA_PRODUCTO', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        
        LogHelper.Out(productoSelected.name, param, 'GET_LINEA_PRESTAMO_PRODUCTO', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_LINEA_PRESTAMO_PRODUCTO', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        
        LogHelper.Out(productoSelected.name, param, 'GET_ATLAS_PARAMETRO_GENERAL', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_ATLAS_PARAMETRO_GENERAL', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        
        LogHelper.Out(productoSelected.name, param, 'GET_CARTERAS_PRODUCTO', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_CARTERAS_PRODUCTO', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        
        LogHelper.Out(productoSelected.name, param, 'GET_MODELO_LIQUIDACION_PRODUCTO', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_MODELO_LIQUIDACION_PRODUCTO', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        
        LogHelper.Out(productoSelected.name, param, 'GET_ATLAS_CATEGORIA_CAJERO_PRODUCTO', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_ATLAS_CATEGORIA_CAJERO_PRODUCTO', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        
        LogHelper.Out(productoSelected.name, param, 'GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        
        LogHelper.Out(productoSelected.name, param, 'GET_PRODUCTO_FORMA_DEBITO_PRODUCTO_ID', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_PRODUCTO_FORMA_DEBITO_PRODUCTO_ID', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        
        LogHelper.Out(productoSelected.name, param, 'GET_HABILITACION_CAJERO_PRODUCTO', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_HABILITACION_CAJERO_PRODUCTO', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        
        LogHelper.Out(productoSelected.name, param, 'GET_ATLAS_MONEDA', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_ATLAS_MONEDA', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        
        LogHelper.Out(productoSelected.name, param, 'GET_ATLAS_ENTIDAD_BANCARIA', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_ATLAS_ENTIDAD_BANCARIA', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        
        LogHelper.Out(productoSelected.name, param, 'GET_ATLAS_TIPO_CUENTA_BANCARIA', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_ATLAS_TIPO_CUENTA_BANCARIA', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');   
       
        LogHelper.Out(productoSelected.name, param, 'GET_TARJETA_TIPO_BY_CUENTA_TIPO', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_TARJETA_TIPO_BY_CUENTA_TIPO', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        
        LogHelper.Out(productoSelected.name, param, 'GET_ATLAS_LIMITE_COMPRA', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_ATLAS_LIMITE_COMPRA', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        
        //LogHelper.Out(productoSelected.name, param, 'GET_SUCURSALES_BY_PRODUCTO', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        //Engine1Proxy.AddDataSourcesRequests(param, 'GET_SUCURSALES_BY_PRODUCTO', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        
        LogHelper.Out(productoSelected.name, param, 'GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        LogHelper.Out(productoSelected.name, parametro, 'GET_EQUIVALENCIA_ATLAS_TIPO_DOCUMENTO_CODIGO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(parametro, 'GET_EQUIVALENCIA_ATLAS_TIPO_DOCUMENTO_CODIGO', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');

        Engine1Proxy.Execute((data) => _productoSelectedCallBack(data, productoId,admin,cuentaTipo ), null, null, "SOLICITUD"); 
    }
    
}


/**
 * FUNCION QUE CREA UN FLAG PARA INDICAR QUE, EN UNA MODIFICACIÓN DE SOLICITUD, LOS DATOS CORRESPONDIENTES A DETERMINADA SECCIÓN HAN SIDO CARGADOS 
 * @param {any} seccionCargada 
 */
export function cargarDatosModificacion(seccionCargada){
    LogHelper.In(cargarDatosModificacion.name, seccionCargada);
    return (dispatch) => {
        _dispatch({ type: CARGAR_DATOS_MODIFICACION, seccionCargada});       
        _dispatch({ type: CARGAR_DATOS_MODIFICACION_TARJETAS, seccionCargada});       
    }
}

/**
 * INDICA QUE SE ESTÁN TRAYENDO LOS DATOS DE PRODUCTO PARA QUE SE MUESTRE EL SPINNER
 * @param {any} payload 
 */
export function retrievingProductData(payload){
    LogHelper.In(retrievingProductData.name, payload);

    return (dispatch) => {
        _dispatch({ type: RETRIEVING_DATA, payload});       
    }
}

/**
 * VALIDACIÓN DE TODOS LOS CAMPOS PREVIA A GUARDAR LA SOLICITUD DE CUENTA
 * @param {any} data 
 */
export function validateCuenta(data) {
    LogHelper.In(validateCuenta.name, data);
    
    return (dispatch, getState) => {
        _dispatch = dispatch;
        
        const state = getState();
        _loadValidateCuenta(data, state); 
    }
}

/**
 * RECUPERA LOS DATOS PERSISTENTES EN TARJETAS CUANDO EL USUARIO SE MUEVE ENTRE PANTALLAS
 */
export function loadDataFromTarjetas(prop){
    LogHelper.In(loadDataFromTarjetas.name);
    
    return (dispatch, getState) => {
        _dispatch = dispatch;
        let state = getState();
        let data = state.tarjetas.solicitudCuenta

        dispatch({
            type: LOAD_DATA_TARJETAS,
            data: data
        });

        dispatch({
            type: FLAG_DATOS_MODIFICACION_CARGADOS,
            list: prop,
            payload: true
        });         
    }
}


/**
 * MANEJA EL MOVIMIENTO ENTRE NUEVA SOLICITUD CUENTA Y NUEVA SOLICITUD ADICIONAL
 */
export function volverASolicitudNSC(){
    LogHelper.In(volverASolicitudNSC.name);
    return (dispatch, getState) => {
        _dispatch = dispatch;

        dispatch({
            type: VOLVER_A_SOLICITUD_NSC,
        });
}
}

/**
 * 
 * @param {any} seccion
 */
export function flagDatosModificacionCargados(seccion){
    LogHelper.In(flagDatosModificacionCargados.name, seccion);
    return (dispatch) => {
        dispatch({
            type: FLAG_DATOS_MODIFICACION_CARGADOS,
            list: seccion,
            payload: true
        });
   }
}

/**
 * TRAE LOS DATOS ORIGINALES DE UNA SOLICITUD PARA PODER PRE CARGARLOS EN UNA MODIFICACIÓN
 * @param {any} solicitud
 */
export function loadModificacionSolicitud(solicitud){

    const param = {
        'ADMINISTRADORA_ID': parseInt(solicitud.marcaId),
        'TIPO_CUENTA': parseInt(solicitud.cuentaTipoId),
        'SOLICITUD_ID': parseInt(solicitud.solicitudId)
    }
    
    return (dispatch, getState) => {
        
        LogHelper.Out(loadModificacionSolicitud.name, null, 'GET_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(null, 'GET_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    
        LogHelper.Out(loadModificacionSolicitud.name, param, 'GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(param, 'GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA', 'Get', 'Tarjetas', 'PARAMETRIA', 1, 'Product');
    
        if(solicitud.marcaId == 1){
            LogHelper.Out(loadModificacionSolicitud.name, param, 'GET_MODIFICACION_SOLICITUD_CUENTA_VISA', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(param, 'GET_MODIFICACION_SOLICITUD_CUENTA_VISA', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        }
        if(solicitud.marcaId == 2){
            LogHelper.Out(loadModificacionSolicitud.name, param, 'GET_MODIFICACION_SOLICITUD_CUENTA_CABAL', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(param, 'GET_MODIFICACION_SOLICITUD_CUENTA_CABAL', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        }
        if(solicitud.SolicitudTipoId == 1){
            LogHelper.Out(loadModificacionSolicitud.name, param, 'GET_EMPRESA_SOLICITADA_BY_ID_SOLICITUD', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
            Engine1Proxy.AddDataSourcesRequests(param, 'GET_EMPRESA_SOLICITADA_BY_ID_SOLICITUD', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        }
            
        Engine1Proxy.Execute((data)=>_loadModificacionSolicitudCallback(data,param,dispatch,solicitud), null, /*permissions*/null, "SOLICITUD"); 
        
    }   
}

/**
 * 
 */
export function hidePopUp() {
    LogHelper.In(hidePopUp.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: ESCONDER_POPUP_SOLICITUD });
    }
}

/**
 * 
 */
export function setRedirectVistaCliente() {
    LogHelper.In(setRedirectVistaCliente.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: SET_REDIRECT_VISTA_CLIENTE });
    }
}

export function guardarBorrador() {
    LogHelper.In(guardarBorrador.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;

        let state = getState();
        let data = state.nuevaSolicitudAdicional;
        data.administradoraId = _tarjetas.administradora.Id;
        data.tipoEmpresa = _tarjetas.tipoEmpresa;
        data.cliente = state.tarjetas.clienteResultadoBusqueda;

        SolicitudManager.GuardarSolicitudBorrador(data, redirectVistaCliente);
    }
}

export function cargarAdicionalesModificacion(){
    LogHelper.In(cargarAdicionalesModificacion.name);
    return (dispatch, getState) => {
        _dispatch = dispatch;

        let state = getState();
        let adicionales = state.tarjetas.cuentasAdicionales;

        dispatch({ type: CARGAR_ADICIONALES_MODIFICACION, payload:adicionales });
        dispatch({ type: CARGAR_ADICIONALES_MODIFICACION_NSC, payload:adicionales });
    }
}

//ACTION QUE BUSCA EL CLIENTE PARA AGREGAR UN ADICIONAL / EXTENSIÓN Y LO GUARDA EN TARJETAS
export function cargarClienteTarjeta(value) {
       /*let parametroDatosFiliatorios = getParametrosWs(value);
    
    LogHelper.Out(buscarPorCuit.name, parametroDatosFiliatorios, 'GETCLIENTEDATOSFILIATORIOS', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');
    Engine1Proxy.AddRuleRequests(parametroDatosFiliatorios, 'GETCLIENTEDATOSFILIATORIOS', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');

    _dispatch({ type: RELOAD_BUSQUEDA_CLIENTE });

    Engine1Proxy.Execute((data)=>_callBackBuscarPorDocumentoDatosFiliatorios(data,parametroDatosFiliatorios), null, null, "CONSULTASOCIOS");
    */
    
    //MOCKEADO HASTA CONSUMIR WS DE CLIENTE CAMBIAR!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    let clienteMock= {
        APELLIDO: "Taylor",
        CliNum: "666",
        Cuit:"21-33556992-6",
        Id: parseInt(Math.random()*10000),
        NOMBRE: "Corey",
        NUMERO_DOCUMENTO: "33.556.992",
        NUMERO_DOCUMENTO_FORMATO: "",
        RAZON_SOCIAL: null,
        TIPO_DOCUMENTO: "DNI",
        TIPO_DOCUMENTO_ID: 1,
        esPersonaFisica: true,
        limiteFormato: ",",
        rank: 512,
        resultadoBD: [
            {
                Apellido: "Taylor",
            CliNum: "666",
            ClienteBancoNumero: 565,
            FisicaJuridica: "F",
            Id: 1,
            Nombre: "Corey",
            NumeroDocumento: "33.556.992",
            RazonSocial: "Slipknot S.A.",
            TipoDocumentoCodigo: "DNI",
            TipoDocumentoId: 1
        }],
        resultadoWS: undefined,
        tipoCliente: "Persona Física",
        tipoDocumentoId: undefined,
        tipoIibbCodigo: undefined,
        tipoIva: undefined,
        unique_id: 565,
        DatosClientes:{
            Cuit:"20-15852555-6",
            NombreCompleto: "Corey",
            ApellidoCompleto:"Taylor",
            RazonSocial:null,
            TipoPersona:"F",
            TipoDocumentoId:1,
            NumeroDocumento:33556992,
            FechaNac:"1967-01-01 00:00:00.000",
            Nacionalidad:4,
            EstadoCivil:2,
            Sexo:"M"
        },
        Domicilios:[
            {
                Direccion:{
                    CodigoDomicilio : "01",
                    CodigoPostal : "1766",
                    Calle: "Lachancha",
                    Numero : "1966",
                    Localidad: "Berazategui",
                    CodigoDomicilio:1,
                    Piso:"1",
                    Departamento:"1" 
                },
                Telefono:{
                    Caracteristica:"011",
                    Numero:"4685-4444"
                }
            }
        ],
        DomiciliosCliente:{
            Calle:"CalleFalsa",
            Numero:"123",
            Piso:0,
            Depto:0,
            Provincia:1,
            CodPostal:"1714",
            Pais: 1,
            Mail:"cachodebuenosaires@machismo.com",
        },
        TelefonosCliente:{
            Telefono:"4699-1822"
        },
        CuentaCliente:{
            NroCuenta:185555222
        }

    }
    let cliente = clienteMock;

    return (dispatch, getState) => {
        _dispatch = dispatch;

        dispatch({ type: CARGAR_CLIENTE_PARA_TARJETA, payload:cliente });
    }

}

/**
 * Call Back que recibe los Datos Filiatorios de cliente a través de la rule
 * @param {any} data
 * @param {any} parametroDatosFiliatorios
 */
function _callBackBuscarPorDocumentoDatosFiliatorios(data, parametroDatosFiliatorios) {
    LogHelper.In(_callBackBuscarPorDocumentoDatosFiliatorios.name, data);

    let clienteDatosFiliatorios = JSON.parse(data.GETCLIENTEDATOSFILIATORIOS);
    let documento = parametroDatosFiliatorios.NRO_DOCUMENTO;

    let codigoIva = "0";

    Array.isArray(clienteDatosFiliatorios.ImpuestosCliente) && clienteDatosFiliatorios.ImpuestosCliente.map(impuesto => { if (impuesto.CodImpuesto == "1") { codigoIva = impuesto.CodCondicion } })

    if (clienteDatosFiliatorios && !clienteDatosFiliatorios.Description) {
        //SI EXISTE LA PROPIEDAD "DESCRIPTION" LA RULE ENCONTRÓ UN ERROR EN LA RESPUESTA DEL WS O BIEN NO ENCONTRÓ EL CLIENTE
        let parameter = {
            'NRO_DOC': documento
        }
        let paramIva = {
            'COD_CONDICION': codigoIva
        }
        let paramOcupacion = {
            'CODIGO': clienteDatosFiliatorios.DatosClientes.ActEconomica,
            'EQUIVALENCIA': 'CORE'
        }
        let paramEstadoCivil = {
            'CODIGO': clienteDatosFiliatorios.DatosClientes.EstadoCivil,
            'EQUIVALENCIA': 'CORE'
        }
        let paramNacionalidad = {
            'CODIGO': clienteDatosFiliatorios.DatosClientes.Nacionalidad,
            'EQUIVALENCIA': 'CORE'
        }


        LogHelper.Out(_callBackBuscarPorDocumentoDatosFiliatorios.name, paramIva, 'GET_ATLAS_CATEGORIA_IVA_CODIGO_X', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramIva, 'GET_ATLAS_CATEGORIA_IVA_CODIGO_X', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');

        LogHelper.Out(_callBackBuscarPorDocumentoDatosFiliatorios.name, paramEstadoCivil, 'GET_ATLAS_ESTADO_CIVIL_POR_CODIGO', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramEstadoCivil, 'GET_ATLAS_ESTADO_CIVIL_POR_CODIGO', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');

        LogHelper.Out(_callBackBuscarPorDocumentoDatosFiliatorios.name, paramOcupacion, 'GET_ATLAS_OCUPACION_POR_CODIGO', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramOcupacion, 'GET_ATLAS_OCUPACION_POR_CODIGO', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');

        LogHelper.Out(_callBackBuscarPorDocumentoDatosFiliatorios.name, paramNacionalidad, 'GET_ATLAS_NACIONALIDAD_POR_CODIGO', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramNacionalidad, 'GET_ATLAS_NACIONALIDAD_POR_CODIGO', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');

        LogHelper.Out(_callBackBuscarPorDocumentoDatosFiliatorios.name, parameter, 'GET_CLIENTE_DOC', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(parameter, 'GET_CLIENTE_DOC', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');

        Engine1Proxy.Execute((datos) => _getClienteByDoc(datos, clienteDatosFiliatorios, documento), null, null, "CONSULTASOCIOS");

    } else {
        _dispatch({ type: NOT_FOUND_CLIENTE, errorBusqueda: clienteDatosFiliatorios.Description ? clienteDatosFiliatorios.Description : null });
    }
}

//función que recibe la data del WS y de nuestra base de datos para generar el objeto "Cliente" que será utilizado en la app
function _getClienteByDoc(datos, dataWS, documento) {

    let clienteDB = JSON.parse(datos.GET_CLIENTE_DOC).Recordset0.Rows;
    let iva = JSON.parse(datos.GET_ATLAS_CATEGORIA_IVA_CODIGO_X).Recordset0.Rows;
    let ocupacion = JSON.parse(datos.GET_ATLAS_OCUPACION_POR_CODIGO).Recordset0.Rows;
    let estadoCivil = JSON.parse(datos.GET_ATLAS_ESTADO_CIVIL_POR_CODIGO).Recordset0.Rows;
    let nacionalidad = JSON.parse(datos.GET_ATLAS_NACIONALIDAD_POR_CODIGO).Recordset0.Rows;
    let clienteWS = dataWS;
    let documentoString = documento.toString();

    documentoString = clienteWS.DatosClientes.TipoPersona == "F" ? documentoString.substring(2, documentoString.length - 1) : documentoString;

    let domAux = {};
    let telAux = {};

    //DOMICILIO Y TELEFONO DEBEN ORGANIZARSE EN EL FORMATO QUE ESTÁ ESPERANDO RECIBIR EL COMPONENTE "EMPRESA"
    if (clienteWS.DomiciliosCliente) {
        domAux = {
            Calle: clienteWS.DomiciliosCliente.Calle,
            CodigoPostal: clienteWS.DomiciliosCliente.CodPostal,
            Depto: clienteWS.DomiciliosCliente.Depto,
            Nivel1: clienteWS.DomiciliosCliente.Nivel1,
            Nivel2: clienteWS.DomiciliosCliente.Nivel2,
            Numero: clienteWS.DomiciliosCliente.Numero,
            Pais: clienteWS.DomiciliosCliente.Pais,
            Localidad: clienteWS.DomiciliosCliente.Localidad,
            Partido: clienteWS.DomiciliosCliente.Partido,
            Piso: clienteWS.DomiciliosCliente.Piso,
            Provincia: clienteWS.DomiciliosCliente.Provincia,
            CodigoDomicilio: clienteWS.DomiciliosCliente.TipoDomicilio,
        }
    }

    if (clienteWS.TelefonosCliente) {
        telAux = {
            Caracteristica: null,
            Numero: clienteWS.TelefonosCliente.Telefono,
            TipoTel: clienteWS.TelefonosCliente.TipoTel
        }
    }

    let clienteFinal = {
        APELLIDO: clienteWS.DatosClientes.Apellido1,
        CliNum: clienteWS.CuentaCliente.NroCuenta,
        CuentaCliente: clienteWS.CuentaCliente.NroCuenta,
        Cuit: documento.toString(),
        DatosClientes: clienteWS.DatosClientes,
        Domicilios: [{ Direccion: domAux, Telefono: telAux }],
        DomiciliosCliente: clienteWS.DomiciliosCliente,
        Id: clienteDB.Id ? clienteDB.Id : 0,
        LimitePorCuit: null,
        NOMBRE: clienteWS.DatosClientes.Nombre1,
        NUMERO_DOCUMENTO: documentoString,
        NUMERO_DOCUMENTO_FORMATO: "",
        RAZON_SOCIAL: clienteWS.DatosClientes.RazonSocial,
        TIPO_DOCUMENTO: clienteWS.DatosClientes.TipoDocumentoId == 0 ? "DNI" : "otro",
        TIPO_DOCUMENTO_ID: clienteWS.DatosClientes.TipoDocumentoId,
        TelefonosCliente: clienteWS.TelefonosCliente,
        esPersonaFisica: clienteWS.DatosClientes.TipoPersona == "F",
        limiteCompraEmpresaOperativa: null,
        limiteFormato: ",",
        resultadoBD: clienteDB,
        tipoCliente: clienteWS.DatosClientes.TipoPersona == "F" ? "Persona Física" : "Persona Jurídica",
        seEncontroEnDB: clienteDB.Id > 0,
        estadoCivilId: clienteWS.DatosClientes.EstadoCivil,
        Nacionalidad: clienteWS.DatosClientes.Nacionalidad,
        ocupacionId: clienteWS.DatosClientes.ActEconomica,
        iva: iva[0] ? iva[0].Descripcion : "",
        ocupacion: ocupacion && ocupacion[0].DESCRIPCION,
        estadoCivil: estadoCivil && estadoCivil[0].DESCRIPCION,
        pais: nacionalidad && nacionalidad[0].DESCRIPCION,
        ClienteListaDocumentos: undefined
    };

    _dispatch({
        type: ACTUALIZAR_ESTADO_CLIENTE,
        cliente: clienteFinal
    });
}

//ACTION QUE, SEGÚN EL USUARIO CONFIRME O NO QUE LOS DATOS SON CORRECTOS, DEJA EL CLIENTE GUARDADO PARA PROCEDER AL ALTA DE ADICIONAL/EXTENSIÓN, O LO BORRA
export function confirmarClienteTarjeta(value,cliente){
    return (dispatch, getState) => {
        _dispatch = dispatch;

        dispatch({ type: CONFIRMAR_CLIENTE_PARA_TARJETA, payload:value,cliente });
    }

}
/*---------------------------------------------- FUNCIONES AUXILIARES ----------------------------------------------*/

function _selectDomicilioVisaCallBack(data,domicilio,dispatch,tipo){
    let payload={};

    let codigos = JSON.parse(data.GET_CODIGO_GEOGRAFICO_VISA).Recordset0.Rows;
    codigos.map(codigo=>{
        codigo.Descripcion = codigo.CodigoGeografico
    })

    payload.domicilio = domicilio.Id
    payload.codigos = codigos
    payload.tipo = tipo
    
    dispatch({ type: SELECT_DOMICILIO_VISA, payload });
}

function _loadModificacionSolicitudCallback(data,param,dispatch,solicitud){
    
    let administradora = JSON.parse(data.GET_ADMINISTRADORA).Recordset0.Rows;
    let tipoEmpresa = JSON.parse(data.GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA).Recordset0.Rows;
    let datosSolicitud = solicitud.marcaId == 1 ? JSON.parse(data.GET_MODIFICACION_SOLICITUD_CUENTA_VISA).Recordset0.Rows : JSON.parse(data.GET_MODIFICACION_SOLICITUD_CUENTA_CABAL).Recordset0.Rows;
    let comunicacion = solicitud.marcaId == 1 ? JSON.parse(data.GET_MODIFICACION_SOLICITUD_CUENTA_VISA).Recordset1.Rows : JSON.parse(data.GET_MODIFICACION_SOLICITUD_CUENTA_CABAL).Recordset1.Rows;
    let cuentasBancarias = solicitud.marcaId == 1 ? JSON.parse(data.GET_MODIFICACION_SOLICITUD_CUENTA_VISA).Recordset2.Rows : JSON.parse(data.GET_MODIFICACION_SOLICITUD_CUENTA_CABAL).Recordset2.Rows;
    let empresaNueva = solicitud.SolicitudTipoId == 1 ? JSON.parse(data.GET_EMPRESA_SOLICITADA_BY_ID_SOLICITUD).Recordset0.Rows[0] : null;
    let empresaSeleccionada =  solicitud.empresaSeleccionada ? solicitud.empresaSeleccionada : null;
    
    let cuentaPesos = null;
    let cuentaDolares = null;

    cuentasBancarias.map(cuenta=>{
        if(cuenta.MonedaId==1){
            cuentaPesos = cuenta.Id;
        }else if(cuenta.MonedaId == 2){
            cuentaDolares = cuenta.Id;
        }
    })

    if(empresaNueva){
        let domiCilioEmpresa= {
            Direccion:{
                Calle: empresaNueva.DomicilioCalle,
                CodigoDomicilio: empresaNueva.DomicilioLod,
                CodigoPostal: empresaNueva.DomicilioCodigoPostal,
                Depto: null,
                Localidad: null,
                Nivel1: null,
                Nivel2: null,
                Numero: empresaNueva.DomicilioNumero,
                Pais: null,
                Partido: empresaNueva.DomicilioDepartamentoPartido,
                Piso: empresaNueva.DomicilioPiso,
                Provincia: null
            },
            Telefono:{
                Caracteristica: null,
                Numero: empresaNueva.Telefono,
                TipoTel: null
            }
        }

        empresaNueva.esNueva = true;
        empresaNueva.seleccionada = true;
        empresaNueva.cartera = {codigo: empresaNueva.CarteraCodigo, id: empresaNueva.CarteraId};
        empresaNueva.categoriaIVA = {codigo: empresaNueva.CategoriaIvaCodigoVisa, id: empresaNueva.CategoriaIvaId};
        empresaNueva.empresaVisaPrecio={Codigo:empresaNueva.TablaPreciosVisaCodigo,Id:empresaNueva.TablaPreciosVisaId}
        empresaNueva.domicilio = domiCilioEmpresa;
        empresaNueva.dateExpiration= empresaNueva.FechaTopeRenovacion;
        empresaNueva.bonificacionAlta = empresaNueva.PorcentajeBonificacionAlta;
        empresaNueva.bonificacionRenovacion = empresaNueva.PorcentajeBonificacionRenovacion;
        empresaNueva.checkAdvance = empresaNueva.PermiteAdelantos;
        empresaNueva.checkPermiteCuotas = empresaNueva.PermiteCuotas;
        empresaNueva.checkLimit = empresaNueva.TieneLimiteTransaccion;
        empresaNueva.checkHomeBanking = empresaNueva.GeneraNuevaClave;
        empresaNueva.report = empresaNueva.DestinatarioReportes;
        empresaNueva.checkExpenses = empresaNueva.TomaGastosModeloLiquidacion;
        empresaNueva.checkUpdateValue = empresaNueva.CobraValorRenovacion;
        empresaNueva.domicilio.Direccion.CodigoDomicilio = empresaNueva.DomicilioBancoTipo;
        empresaNueva.codeGeographic = empresaNueva.DomicilioCodigoGeografico;
        empresaNueva.checkEsConfidencial = empresaNueva.EsConfidencial;
        empresaNueva.checkReport = empresaNueva.GeneraReporteCuentaCentral;
        empresaNueva.checkForeign = empresaNueva.PermiteConsumosExterior;
        empresaNueva.vigenciaDesdeAlta = empresaNueva.VigenciaAlta;
        empresaNueva.vigenciaDesdeLaRenovacion = empresaNueva.VigenciaRenovacion;
    }

    let tarjetasSolicitud = solicitud.Tarjetas;
    let tarjetasMapeadas = [];
    
    //SE CREA UN NUEVO ARREGLO DE TARJETAS PARA QUE LOS DATOS TRAIDOS DE LA BASE TENGAN EL NOMBRE REQUERIDO POR EL COMPONENTE "NuevaSolicitudAdicionales"
    tarjetasSolicitud.map((tarjeta,indice)=>{
        
        let nombreDenominacion="";
        let apellidoDenominacion="";

        if(tarjeta.Denominacion && tarjeta.Denominacion.includes('/')){
            nombreDenominacion=tarjeta.Denominacion.split('/')[1];
            apellidoDenominacion=tarjeta.Denominacion.split('/')[0];
        }

        let obj = {};
        //es necesario que los adicionales tengan este objeto que contiene los datos del cliente para su manejo por NuevaSolicitudAdicional y SolicitudManager
        let ClienteTarjetas = {
            Apellido:apellidoDenominacion,
            Nombre:nombreDenominacion,
            APELLIDO: tarjeta.Apellido,
            Denominacion: tarjeta.Denominacion,
            ApellidoCompleto: tarjeta.Apellido,
            CliNum: tarjeta.ClienteBancoNumero,
            CuentaCliente: "",
            Cuit: tarjeta.Cuit,
            IIBBId: tarjeta.TipoIibbId,
            Id: tarjeta.IdCliente,
            NOMBRE: tarjeta.Nombre,
            NUMERO_DOCUMENTO: tarjeta.NumeroDocumento,
            Nacionalidad: tarjeta.NacionalidadId,
            NombreCompleto: tarjeta.Nombre,
            RAZON_SOCIAL: tarjeta.RazonSocial,
            TIPO_DOCUMENTO_ID: tarjeta.TipoDocumentoId,
            esPersonaFisica: tarjeta.FisicaJuridica == "F",
            estadoCivilId: tarjeta.EstadoCivilId,
            gananciasId: tarjeta.CategoriaGananciasId,
            identidadCliente:tarjeta.Nombre + " " + tarjeta.Apellido,
            ocupacionId: tarjeta.OcupacionId,
            tipoCliente: tarjeta.FisicaJuridica == "F" ? "Persona Física":"Persona Jurídica",
            tipoIva: tarjeta.CategoriaIvaId,
            nacionalidadVisa: tarjeta.NacionalidadCodigoVisa ? tarjeta.NacionalidadCodigoVisa : null ,
            estadoCivilVisa: tarjeta.EstadoCivilCodigoVisa ? tarjeta.EstadoCivilCodigoVisa : null ,
            ocupacionVisa: tarjeta.OcupacionCodigoVisa ? tarjeta.OcupacionCodigoVisa : null ,
            estadoCivilCabalDoc:tarjeta.EstadoCivilCodigo ? tarjeta.EstadoCivilCodigo : null,
            ocupacionCabalDoc:tarjeta.ProfesionCodigo ? tarjeta.ProfesionCodigo : null,
            codigoCabalDoc:tarjeta.DocumentoTipoCodigo ? tarjeta.DocumentoTipoCodigo : null,
            documentoCodigoVisa:tarjeta.DocumentoTipoCodigoVisa,
            DatosClientes:{
                TipoPersona:tarjeta.FisicaJuridica,
                Sexo:tarjeta.Sexo,
                FechaNac:tarjeta.FechaNacimiento ? tarjeta.FechaNacimiento.replace(/-/g,"").substring(0,8):""
            }
            };

        

        obj.Apellido = apellidoDenominacion
        obj.EsTitular = tarjeta.EsAdicional == "0"
        obj.CodigoDistribucionId = tarjeta.DistribucionId ? tarjeta.DistribucionId : tarjeta.CodigoDistribucionId
        obj.CuotasEmision = tarjeta.Cuotas ? tarjeta.Cuotas : tarjeta.cuotasEmision
        obj.HabilitacionCajeroId = tarjeta.HabilitacionCajerosId ? tarjeta.HabilitacionCajerosId : tarjeta.HabilitacionCajeroId
        obj.IdAdicional = tarjeta.TarjetaCreditoId ? parseInt(tarjeta.TarjetaCreditoId) : tarjeta.IdAdicional// id de tarjeta para base de datos, este no se modifica 
        obj.idAdicional = indice+1 //id que se le asigna para tratarlo en el front, sin relacion con IdAdicional
        obj.LimiteDeAdelantos = tarjeta.PorcentajeLimiteAdelantos ? tarjeta.PorcentajeLimiteAdelantos : tarjeta.LimiteDeAdelantos
        obj.LimiteDeCEC = tarjeta.PorcentajeLimiteCompraCuotas ? tarjeta.PorcentajeLimiteCompraCuotas : tarjeta.LimiteDeCEC
        obj.LimiteDeCompra = tarjeta.PorcentajeLimiteCompra ? tarjeta.PorcentajeLimiteCompra : tarjeta.LimiteDeCompra
        obj.LimiteCompraMontoCabal = tarjeta.LimiteCompraTarjeta ? tarjeta.LimiteCompraTarjeta : tarjeta.LimiteDeCompra
        obj.Nombre = nombreDenominacion
        obj.PorcentajeEmision = !isNaN(parseInt(tarjeta.Bonificacion)) ? parseInt(tarjeta.Bonificacion) : (tarjeta.PorcentajeEmision ? tarjeta.PorcentajeEmision : null)
        obj.denominacionCuartaLinea = tarjeta.CuartaLinea
        obj.FechaVigenciaDesde = tarjeta.FechaVigenciaDesde
        obj.FechaVigenciaHasta = tarjeta.FechaVigenciaHasta
        obj.LimitePorTransaccion = tarjeta.LimitePorTransaccion
        obj.SeleccionLimiteTransaccionClienteAdicional = tarjeta.LimitePorTransaccion && tarjeta.LimitePorTransaccion > 0 
        obj.codigoAreaCentroDeCostos = tarjeta.codigoAreaCentroDeCostos
        obj.codigoSectorCentroDeCostos = tarjeta.codigoSectorCentroDeCostos
        obj.seleccionaTarjetaTemporal = tarjeta.seleccionaTarjetaTemporal
        obj.usoCajerosConCargo = tarjeta.usoCajerosConCargo
        obj.vigenciaTemporalId = tarjeta.vigenciaTemporalId
        obj.seleccionaTarjetaTemporal = tarjeta.vigenciaTemporalId ? true:false
        obj.TarjetaCreditoVisaId = tarjeta.TarjetaCreditoVisaId
        obj.TarjetaCreditoCabalId = tarjeta.TarjetaCreditoCabalId
        obj.ClienteTarjetas=ClienteTarjetas;
        tarjetasMapeadas.push(obj);
    })

    administradora = administradora.filter(adm=>adm.Id == param.ADMINISTRADORA_ID);
    tipoEmpresa = tipoEmpresa.filter(tipo=>tipo.Id == datosSolicitud[0].CuentaTipoId);

    let payload = {}

    payload.administradora = administradora[0];
    payload.tipoEmpresa = tipoEmpresa[0];
    payload.datosSolicitud = datosSolicitud[0];
    payload.datosSolicitud.Comunicacion = comunicacion;
    payload.datosSolicitud.tarjetasSolicitud = tarjetasSolicitud;
    payload.datosSolicitud.tarjetasMapeadas = tarjetasMapeadas;
    payload.datosSolicitud.solicitudId = solicitud.solicitudId;
    payload.datosSolicitud.cuentaPesosId =  cuentaPesos;
    payload.datosSolicitud.cuentaDolaresId = cuentaDolares;
    payload.empresaNueva = empresaNueva;
    payload.empresaSeleccionada = solicitud.empresaSeleccionada;
    
     dispatch({ type: LOAD_MODIFICACION_SOLICITUD_TARJETAS, payload});   
}


function _selectSucursalCallBack(data,adm){
    let PRODUCTO =[];
    
    if(adm == 1){
        PRODUCTO = JSON.parse(data.GET_PRODUCTOS_BY_SUCURSAL_VISA).Recordset0.Rows
    }else{
        PRODUCTO = JSON.parse(data.GET_PRODUCTOS_BY_SUCURSAL_CABAL).Recordset0.Rows
    }
    

    _dispatch({ type: GET_PRODUCTOS_BY_SUCURSAL, PRODUCTO });
    _dispatch({ type: SAVE_SOLICITUD_CUENTA_SELECCION,prop:"PRODUCTO", value:PRODUCTO });
    
}

/**
 * 
 * @param {any} data
 */
function _cargarDatosPantalla(data) {
    LogHelper.In(_cargarDatosPantalla.name, data);
    userFeatures = JSON.parse(JSON.stringify(data));

    let adminEmpCueTarFunctions = JSON.parse(JSON.stringify(data.ADMINEMPCUETAR));
    let adminEmpCueTarFunctionsAllowed = [];

    let solicitudFunctions = JSON.parse(JSON.stringify(data.SOLICITUD));
    let solicitudFunctionsAllowed = [];

    let permisos = {
        componentes: {
            Pantalla: { Active: false, Locked: false },
            RadioButtons: { Active: false, Locked: false },
            BotonesAnteriorSiguiente: { Active: false, Locked: false },
            BotonNuevaCuenta: { Active: false, Locked: false },
            BotonDistribuirLimites: { Active: false, Locked: false },
            IconoDeOjo: { Active: false, Locked: false },
            BotonGuardarBorrador: { Active: false, Locked: false }
        },
        adminEmpCueTarFunctionsAllowed: {},
        solicitudFunctionsAllowed: {}
    };

    adminEmpCueTarFunctions.forEach(p => { permisos.adminEmpCueTarFunctionsAllowed[p.Codigo_Funcion] = true; });
    solicitudFunctions.forEach(p => { permisos.solicitudFunctionsAllowed[p.Codigo_Funcion] = true; });

    /*if (_tarjetas.esModificacion == true) {
        switch (_tarjetas.estadoSolicitud.toLowerCase()) {
            case "borrador": {
                if (permisos.solicitudFunctionsAllowed.Consulta == true) {
                    permisos.componentes.Pantalla.Active = true
                    permisos.componentes.BotonesAnteriorSiguiente.Active = true;
                    permisos.componentes.IconoDeOjo.Active = true;

                    if (permisos.solicitudFunctionsAllowed.Modificacion == true) {
                        permisos.componentes.RadioButtons.Active = true;
                        permisos.componentes.BotonNuevaCuenta.Active = true;
                        permisos.componentes.BotonDistribuirLimites.Active = true;
                        permisos.componentes.BotonGuardarBorrador.Active = true;
                    } else {
                        if ((permisos.solicitudFunctionsAllowed.Distribucion == true)
                            || (permisos.solicitudFunctionsAllowed.Confirmacion == true)) {
                            permisos.componentes.BotonDistribuirLimites.Active = true;
                        }
                    }
                } else {
                    //Si no tiene permisos sobre la consulta, no es necesario que valide las demas funciones, ya que 
                   // no será capaz de acceder a la pantalla
                    permisos.componentes.Pantalla = { Active: false }
                };
                break;
            }
            case "cuenta / tarjeta parcialmente aceptada por adm":
            case "cuenta / tarjeta rechazada por adm":
            case "empresa rechazada por adm":
            case "denegada banco":
            case "completada":
            case "confirmada": {
                if (permisos.solicitudFunctionsAllowed.Consulta == true) {
                    permisos.componentes.Pantalla.Active = true
                    permisos.componentes.BotonesAnteriorSiguiente.Active = true;
                    permisos.componentes.IconoDeOjo.Active = true;
                    permisos.componentes.BotonDistribuirLimites.Active = true;

                    let completadaResult = _tarjetas.estadoSolicitud.toLowerCase() == "completada"
                        && (permisos.solicitudFunctionsAllowed.Modificacion == true);

                    let confirmadaResult = _tarjetas.estadoSolicitud.toLowerCase() == "confirmada"
                        && (permisos.solicitudFunctionsAllowed.Modificacion == true);

                    let denegadaResult = _tarjetas.estadoSolicitud.toLowerCase() == "denegada banco"
                        && (permisos.solicitudFunctionsAllowed.Modificacion == true);

                    let ctpResult = _tarjetas.estadoSolicitud.toLowerCase() == "cuenta / tarjeta parcialmente aceptada por adm"
                        && (permisos.solicitudFunctionsAllowed.Modificacion == true);

                    let ctrResult = _tarjetas.estadoSolicitud.toLowerCase() == "cuenta / tarjeta rechazada por adm"
                        && (permisos.solicitudFunctionsAllowed.Modificacion == true);

                    let erResult = _tarjetas.estadoSolicitud.toLowerCase() == "empresa rechazada por adm"
                        && (permisos.solicitudFunctionsAllowed.Modificacion == true);

                    if (completadaResult || confirmadaResult || denegadaResult || ctpResult || ctrResult || erResult) {
                        permisos.componentes.RadioButtons.Active = true;
                        permisos.componentes.BotonNuevaCuenta.Active = true;
                        permisos.componentes.BotonGuardarBorrador.Active = true;
                    }
                } else {
                    //Si no tiene permisos sobre la consulta, no es necesario que valide las demas funciones, ya que 
                   // no será capaz de acceder a la pantalla
                    permisos.componentes.Pantalla = { Active: false }
                };
                break;
            }
            case "enviada": {
                if (permisos.solicitudFunctionsAllowed.Consulta == true) {
                    permisos.componentes.Pantalla.Active = true
                    permisos.componentes.BotonesAnteriorSiguiente.Active = true;
                    permisos.componentes.IconoDeOjo.Active = true;

                    permisos.componentes.BotonDistribuirLimites = { Active: true, Locked: true };
                    permisos.componentes.RadioButtons = { Active: true, Locked: true };
                    permisos.componentes.BotonNuevaCuenta = { Active: true, Locked: true };
                    permisos.componentes.BotonGuardarBorrador = { Active: true, Locked: true };
                } else {
                    //Si no tiene permisos sobre la consulta, no es necesario que valide las demas funciones, ya que 
                    //no será capaz de acceder a la pantalla
                    permisos.componentes.Pantalla = { Active: false }
                };
                break;
            }
            default: {
                break;
            }
        }
    } else {*/
        if (permisos.adminEmpCueTarFunctionsAllowed.Alta == true) {
            permisos.componentes.Pantalla.Active = true;
            permisos.componentes.RadioButtons.Active = true;
            permisos.componentes.BotonNuevaCuenta.Active = true;
            permisos.componentes.BotonGuardarBorrador.Active = true;

            if (permisos.solicitudFunctionsAllowed.Consulta == true) {
                permisos.componentes.BotonesAnteriorSiguiente.Active = true;
                permisos.componentes.IconoDeOjo.Active = true;
            }
            if (permisos.solicitudFunctionsAllowed.Distribucion == true) {
                permisos.componentes.BotonDistribuirLimites.Active = true;
            }
        } else {
            /*Si no tiene permisos sobre la consulta, no es necesario que valide las demas funciones, ya que no
            será capaz de acceder a la pantalla*/
            permisos.componentes.Pantalla.Active = false;
        }
    //}

    if (permisos.componentes.Pantalla.Active == true) {
        let param;
        //let cuit = _tarjetas.cliente.Cuit;
        let tipoCuentaId = _tarjetas.tipoEmpresa.Id;
        let admId = _tarjetas.administradora.Id;
        
        //if (!isNaN(cuit)) {
        //    param = { "CUIT": cuit }
        //} else {
        //    if (cuit.indexOf("-") > -1) {
        //        param = { "CUIT": parseInt(cuit.split("-").join("")) }
        //    } else {
        //        param = { "CUIT": parseInt(cuit) }
        //    }
        //}

        const localValue = {
            'MARCA': admId,
            'TIPO_CUENTA': tipoCuentaId
        }
        const producto = {
            'PRODUCTO_ID': 1
        }
        const cuentaTarjetaId = {
            'CUENTA_TARJETA_ID': 1
        }
        const paramDomicilio = {
            'FILTRO_ID_CLIENTE': _tarjetas.clienteResultadoBusqueda.Cuit ? _tarjetas.clienteResultadoBusqueda.Cuit : 0
        }
        
        switch (admId) {
            case 1: //VISA
                //GET_SOLICITUD_CUENTA_VISA_1
                LogHelper.Out(_cargarDatosPantalla.name, localValue, 'GET_SOLICITUD_CUENTA_VISA_1', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
                Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_SOLICITUD_CUENTA_VISA_1', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');

                //GET_SOLICITUD_CUENTA_VISA_2
                LogHelper.Out(_cargarDatosPantalla.name, null, 'GET_SOLICITUD_CUENTA_VISA_2', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
                Engine1Proxy.AddDataSourcesRequests(null, 'GET_SOLICITUD_CUENTA_VISA_2', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');

                LogHelper.Out(_cargarDatosPantalla.name, localValue, 'GET_SUBTIPO_CUENTA', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
                Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_SUBTIPO_CUENTA', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');

                break;

            case 2: //CABAL
                //GET_SOLICITUD_CUENTA_CABAL_1
                LogHelper.Out(_cargarDatosPantalla.name, localValue, 'GET_SOLICITUD_CUENTA_CABAL_1', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
                Engine1Proxy.AddDataSourcesRequests(localValue, 'GET_SOLICITUD_CUENTA_CABAL_1', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
                
                break;
            }
        
        LogHelper.Out(_cargarDatosPantalla.name, paramDomicilio, 'GET_DOMICILIOS', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
        Engine1Proxy.AddDataSourcesRequests(paramDomicilio, 'GET_DOMICILIOS', 'Get', 'Tarjetas', 'SOLICITUD', 1, 'Product');
            
        param = { 'ADMINISTRADORA_ID': parseInt(admId) };

        Engine1Proxy.Execute((data) => _cargarDatosPantallaCallback(data, admId), null, permisos, "SOLICITUD");
    } else {
        _dispatch({ type: ACTUALIZAR_ESTADO_DISTRIBUCION_CUENTA });
        _dispatch({ type: GET_SCREEN_DATA_CUENTA, resultado: permisos });
    }
}

/**
 * 
 * @param {any} data
 * @param {any} permisos
 */
function _cargarDatosPantallaCallback(data, admId) {
    LogHelper.In(_cargarDatosPantallaCallback.name, data);

    let cliente = _tarjetas.clienteResultadoBusqueda;
    let arregloDomicilios = [];
    let arregloTelefonos = [];
    let arregloCelulares=[];
    const getDomiciliosBase = JSON.parse(data.GET_DOMICILIOS).Recordset0.Rows;
    
    if(cliente){
        //LOS COMBOS DE DIRECCIÓN, TELÉFONO Y CELULAR SE LLENAN CON LA INFORMACIÓN DEL WS QUE TRAE EL CLIENTE
        cliente.Domicilios.map(domicilio=>{
            let idBase= null;
            //SE RECORREN LOS DOMICILIOS PARA EL CLIENTE REGISTRADOS EN DB, SI COINCIDEN CON ALGUNO DE LOS TRAIDOS POR EL WS SE LE ASIGNA EL ID QUE TIENEN EN DB
            getDomiciliosBase.map(dom=>{
                let stringAux = dom.Calle+dom.Numero;
                let stringAux2 = domicilio.Direccion.Calle+domicilio.Direccion.Numero;
                if(stringAux == stringAux2) idBase = dom.Id
                
            })
            arregloDomicilios.push({
                Id:idBase ?  idBase:domicilio.Direccion.Calle+domicilio.Direccion.Numero,
                Descripcion: domicilio.Direccion.Calle+ "  " + domicilio.Direccion.Numero + " - " + domicilio.Direccion.Localidad,
                CodigoPostal:domicilio.Direccion.CodigoPostal,
                Calle: domicilio.Direccion.Calle,
                CodigoDomicilio:domicilio.Direccion.CodigoDomicilio,
                Depto: domicilio.Direccion.Depto,
                Localidad: domicilio.Direccion.Localidad,
                Partido: domicilio.Direccion.Partido,
                Nivel1: domicilio.Direccion.Nivel1,
                Nivel2: domicilio.Direccion.Nivel2,
                Numero: domicilio.Direccion.Numero,
                Pais: domicilio.Direccion.Pais,
                Piso: domicilio.Direccion.Piso,
                Provincia: domicilio.Direccion.Provincia
            })
            if(domicilio.Telefono.Numero && domicilio.Telefono.Numero.length >0 ){
                if(domicilio.Telefono.Numero.length <10){
                    arregloTelefonos.push({
                        Id: domicilio.Telefono.Numero,
                        Descripcion: domicilio.Telefono.Numero
                    })
                }else{
                    arregloCelulares.push({
                        Id: domicilio.Telefono.Numero,
                        Descripcion: domicilio.Telefono.Numero
                    })
                }
            }
        })
        
    }

    if(_tarjetas.esModificacion && _tarjetas.datosSolicitud){
        //SI SE TRATA DE UNA MODIFICACION, EN CASO DE SER UNA SOLICITUD HECHA POR WEB SERVICE, EL TELÉFONO QUE SE INGRESÓ PUEDE NO EXISTIR EN EL CORE, POR LO QUE HAY QUE AGREGARLO
        let celularGuardadoSolicitudPorWS = null;
        
        let arregloCelularesAuxiliar = [];

        _tarjetas.datosSolicitud.Comunicacion.map(forma=>{
            if(forma.codigoTipoComunicacion =="CELULAR"){
                celularGuardadoSolicitudPorWS = JSON.parse(JSON.stringify(forma));
                celularGuardadoSolicitudPorWS.Id= celularGuardadoSolicitudPorWS.FormaComunicacionId;
                celularGuardadoSolicitudPorWS.Descripcion = celularGuardadoSolicitudPorWS.Contacto
            } 
        })

        if(celularGuardadoSolicitudPorWS){
            //SI HABÍA UN CELULAR GUARDADO EN LA SOLICITUD POR WS, ANTES DE AGREGARLO AL ARREGLO VERIFICO QUE NO ESTÉ PRESENTE TAMBIÉN EN EL ARREGLO QUE PROVIENE DEL WEB SERVICE DE CLIENTE
            arregloCelulares.map(cel=>{
                if(cel.Descripcion != celularGuardadoSolicitudPorWS.Descripcion) arregloCelularesAuxiliar.push(cel)
            })
            arregloCelularesAuxiliar.push(celularGuardadoSolicitudPorWS)
            arregloCelulares = JSON.parse(JSON.stringify(arregloCelularesAuxiliar));
        } 
    }
    
    let resultado = {}
    switch (admId) {
        case 1: //VISA
            const getSolicitudCuentaVisa1 = JSON.parse(data.GET_SOLICITUD_CUENTA_VISA_1);
            const getSolicitudCuentaVisa2 = JSON.parse(data.GET_SOLICITUD_CUENTA_VISA_2);
            const subCuentas = JSON.parse(data.GET_SUBTIPO_CUENTA).Recordset0.Rows;
            //const getSolicitudCuentaVisa3 = JSON.parse(data.GET_SOLICITUD_CUENTA_VISA_3);
            
            resultado = {
                'cuentas': [],
                'ATLAS_SUCURSALES': getSolicitudCuentaVisa1.Recordset0.Rows,
                'PRODUCTO': getSolicitudCuentaVisa1.Recordset1.Rows,
                'ATLAS_TIPO_CUENTA': getSolicitudCuentaVisa1.Recordset2.Rows,
                'ATLAS_COMERCIALIZADORA': getSolicitudCuentaVisa1.Recordset5.Rows,
                'ATLAS_PROMOTOR': getSolicitudCuentaVisa1.Recordset6.Rows,
                'PRODUCTO_DEFAULT_VISA_1': /*getSolicitudCuentaVisa1.Recordset7.Rows*/[],
                'ATLAS_CODIGO_GEOGRAFICO': getSolicitudCuentaVisa2.Recordset0.Rows,
                'ATLAS_TIPO_COMUNICACION': getSolicitudCuentaVisa2.Recordset1.Rows,
                'GET_SUBTIPO_CUENTA': subCuentas,
                'PRODUCTO_VISA': /*getSolicitudCuentaVisa3.Recordset0.Rows*/[],
                'PRODUCTO_DEFAULT_VISA_2': /*getSolicitudCuentaVisa3.Recordset1.Rows*/[],
                'TELEFONOS_CLIENTE':arregloTelefonos,
                'CELULARES_CLIENTE':arregloCelulares,
                'DOMICILIOS_CLIENTE':arregloDomicilios,
                'DOMICILIOS_BASE':getDomiciliosBase,
                 'ClienteListaDocumentos': undefined
            };
            
            break;
            
            case 2: //CABAL
            const getSolicitudCuentaCabal1 = JSON.parse(data.GET_SOLICITUD_CUENTA_CABAL_1);
            
            resultado = {
                'cuentas': [],
                'empresaSeleccionada': [],//_tarjetas.empresas.find((empresa) => { return empresa.seleccionada == true }),
                'ATLAS_SUCURSALES': getSolicitudCuentaCabal1.Recordset0.Rows,
                'PRODUCTO': getSolicitudCuentaCabal1.Recordset1.Rows,
                'ATLAS_PROMOTOR': getSolicitudCuentaCabal1.Recordset5.Rows,
                'PRODUCTO_DEFAULT_CABAL_1': /*getSolicitudCuentaCabal1.Recordset6.Rows*/[],
                'ATLAS_TIPO_COMUNICACION': getSolicitudCuentaCabal1.Recordset7.Rows,
                'PRODUCTO_CABAL': /*getSolicitudCuentaCabal3.Recordset0.Rows*/[],
                'PRODUCTO_DEFAULT_CABAL_2': /*getSolicitudCuentaCabal3.Recordset1.Rows*/[],
                'montoMinimoMaximo': /*getSolicitudCuentaCabal4.Recordset0.Rows*/[],
                'coefLimiteCompraCuotas': /*getSolicitudCuentaCabal4.Recordset1.Rows*/[],
                'PRODUCTO_DEFAULT_CABAL_3': /*getSolicitudCuentaCabal4.Recordset2.Rows*/[],
                'TELEFONOS_CLIENTE':arregloTelefonos,
                'CELULARES_CLIENTE':arregloCelulares,
                'DOMICILIOS_CLIENTE':arregloDomicilios,
                'DOMICILIOS_BASE':getDomiciliosBase,
                'ClienteListaDocumentos': undefined
            };
            break;
            default:
        }
        
        
        //SE GUARDAN LAS CUENTAS EN DOLARES Y PESOS Y <<SOLO>> LAS SUCURSALES DONDE HAY CUENTAS POR SEPARADO PARA QUE ÚNICAMENTE SE MUESTREN
        //ÉSTAS EN EL COMPONENTE "FORMA DE PAGO"
        const cuentasCliente = _tarjetas.clienteResultadoBusqueda.clienteListaDocumentos;
        
        let numeroSucursalesPesos=[];
        let numeroSucursalesDolar=[];
        let sucursalPesos = [];
        let cuentaPesos = cuentasCliente ? cuentasCliente.filter((cuenta=>cuenta.Moneda=="80")) : [];
        let sucursalDolares = [];
        let cuentaDolares = cuentasCliente ? cuentasCliente.filter((cuenta=>cuenta.Moneda!="80")) : [];
        
        cuentaPesos.map(cuentaP=>{
            numeroSucursalesPesos.push(cuentaP.Sucursal)
        })
        
        resultado.ATLAS_SUCURSALES.map(sucursal=>{
            numeroSucursalesPesos.map(numero=>{
                if(sucursal.VALOR_X==numero) sucursalPesos.push(sucursal)
            })
        })
        
        cuentaDolares.map(cuentaD=>{
            numeroSucursalesDolar.push(cuentaD.Sucursal)
        })
        
        resultado.ATLAS_SUCURSALES.map(sucursal=>{
            numeroSucursalesDolar.map(numero=>{
                if(sucursal.VALOR_X==numero) sucursalDolares.push(sucursal)
            })
        })

        //GUARDO EN LAS CUENTAS EL ID DE SUCURSAL PARA NUESTRA DB CON EL FIN DE PODER IDENTIFICARLA A LA HORA DE GUARDAR LA SOLICITUD
        _tarjetas.clienteResultadoBusqueda.clienteListaDocumentos && _tarjetas.clienteResultadoBusqueda.clienteListaDocumentos.map(cuenta=>{
            let sucursales = sucursalPesos.concat(sucursalDolares);
            
            sucursales.map(suc=>{
                if(suc.VALOR_X == cuenta.Sucursal){
                    cuenta.SucursalId = suc.Id;
                    cuenta.tieneEquivalenciaSucursal = true;  
                } 
            })
        })
        if(_tarjetas.clienteResultadoBusqueda.clienteListaDocumentos){
            _tarjetas.clienteResultadoBusqueda.clienteListaDocumentos = _tarjetas.clienteResultadoBusqueda.clienteListaDocumentos.filter(cuenta=>cuenta.tieneEquivalenciaSucursal) 
        } 
        resultado.SUCURSALES_CUENTAS_PESOS = sucursalPesos;
        resultado.SUCURSALES_CUENTAS_DOLARES = sucursalDolares;

        let datos=resultado;
        let cuentasFinal= _tarjetas.clienteResultadoBusqueda.clienteListaDocumentos;
        
        datos.ERROR_CUENTA = _NuevaSolicitudCuentaData.ERROR_CUENTA;
        
        datos.ClienteListaDocumentos = _tarjetas.clienteResultadoBusqueda.ClienteListaDocumentos;

        datos.cuentasFinal = cuentasFinal;
        
        _dispatch({ type: GET_SCREEN_DATA_CUENTA, resultado, idSolicitud:/* _tarjetas.id*/0 });
        
    //COPIA LA INFORMACIÓN A TARJETAS, EL STORE QUE PERSISTE
    _dispatch({ type: SAVE_SOLICITUD_CUENTA_SELECCION, prop:"getScreenNSC", value :datos });

}

/**
 * 
 * @param {any} data
 * @param {any} productoId
 * @param {any} administradora
 */
function _productoSelectedCallBack(data, productoId, administradora,cuentaTipo) {
    let result
    switch (administradora){
        case 1:{

            let comercializadoras = JSON.parse(data.GET_COMERCIALIZADORA_CANAL_VENTA_BY_PRODUCTO).Recordset0.Rows;

            comercializadoras.map(row=>row.Descripcion = row.DescripcionComercializadora + " - "+ row.DescripcionCanalVenta)

            let modalidadDistribucionLimite = JSON.parse(data.GET_MODALIDAD_DISTRIBUCION_LIMITE_PRODUCTO_ID).Recordset0.Rows;

            modalidadDistribucionLimite.map(mod=>mod.Id=mod.ModalidadDistribucionLimiteId)
            
            result = {
                'GET_PRODUCTO_VISA_PRODUCTO_ID': JSON.parse(data.GET_PRODUCTO_VISA_PRODUCTO_ID).Recordset0.Rows[0],
                'GET_MODALIDAD_DISTRIBUCION_LIMITE_PRODUCTO_ID': modalidadDistribucionLimite,
                'GET_LIMITE_COMPRA_PRODUCTO': JSON.parse(data.GET_LIMITE_COMPRA_PRODUCTO).Recordset0.Rows,
                'GET_LINEA_PRESTAMO_PRODUCTO': JSON.parse(data.GET_LINEA_PRESTAMO_PRODUCTO).Recordset0.Rows,
                'GET_PRODUCTO_DEFAULT_VISA_PRODUCTO': JSON.parse(data.GET_PRODUCTO_DEFAULT_VISA_PRODUCTO).Recordset0.Rows[0],
                'GET_ATLAS_PARAMETRO_GENERAL': JSON.parse(data.GET_ATLAS_PARAMETRO_GENERAL).Recordset0.Rows,
                'GET_CARTERAS_PRODUCTO': JSON.parse(data.GET_CARTERAS_PRODUCTO).Recordset0.Rows,
                'GET_CARTERAS_EMPRESA': JSON.parse(data.GET_CARTERAS_EMPRESA).Recordset0.Rows,
                'GET_MODELO_LIQUIDACION_PRODUCTO': JSON.parse(data.GET_MODELO_LIQUIDACION_PRODUCTO).Recordset0.Rows,
                'GET_ATLAS_CATEGORIA_CAJERO_PRODUCTO': JSON.parse(data.GET_ATLAS_CATEGORIA_CAJERO_PRODUCTO).Recordset0.Rows,
                'GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID': JSON.parse(data.GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID).Recordset0.Rows,
                'GET_PRODUCTO_FORMA_DEBITO_PRODUCTO_ID': JSON.parse(data.GET_PRODUCTO_FORMA_DEBITO_PRODUCTO_ID).Recordset0.Rows,
                'GET_SUCURSAL_CLIENTE_CUENTA': JSON.parse(data.GET_SUCURSAL_CLIENTE_CUENTA).Recordset0.Rows,
                'GET_HABILITACION_CAJERO_PRODUCTO': JSON.parse(data.GET_HABILITACION_CAJERO_PRODUCTO).Recordset0.Rows,
                'GET_ATLAS_MONEDA': JSON.parse(data.GET_ATLAS_MONEDA).Recordset0.Rows,
                'GET_ATLAS_ENTIDAD_BANCARIA': JSON.parse(data.GET_ATLAS_ENTIDAD_BANCARIA).Recordset0.Rows,
                'GET_ATLAS_TIPO_CUENTA_BANCARIA': JSON.parse(data.GET_ATLAS_TIPO_CUENTA_BANCARIA).Recordset0.Rows,
                'GET_TARJETA_TIPO_BY_CUENTA_TIPO': JSON.parse(data.GET_TARJETA_TIPO_BY_CUENTA_TIPO).Recordset0.Rows,
                'GET_ATLAS_LIMITE_COMPRA': JSON.parse(data.GET_ATLAS_LIMITE_COMPRA).Recordset0.Rows,
                'ATLAS_GRUPO_AFINIDAD': JSON.parse(data.GET_GRUPOS_AFINIDAD_BY_PRODUCTO).Recordset0.Rows,
                'GET_CODIGO_DISTRIBUCION_BY_PRODUCTO_ID': JSON.parse(data.GET_CODIGO_DISTRIBUCION_BY_PRODUCTO_ID).Recordset0.Rows,
                'productoId': productoId,
                'GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA': JSON.parse(data.GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA).Recordset0.Rows.filter(c => c.Id == cuentaTipo),
                'GET_EQUIVALENCIA_ATLAS_TIPO_DOCUMENTO_CODIGO': JSON.parse(data.GET_EQUIVALENCIA_ATLAS_TIPO_DOCUMENTO_CODIGO).Recordset0.Rows,
                'ATLAS_COMERCIALIZADORA': comercializadoras
            }
            break
        }
        case 2:{
            
            result = {
                'GET_LIMITE_COMPRA_PRODUCTO': JSON.parse(data.GET_LIMITE_COMPRA_PRODUCTO).Recordset0.Rows,
                'GET_LINEA_PRESTAMO_PRODUCTO': JSON.parse(data.GET_LINEA_PRESTAMO_PRODUCTO).Recordset0.Rows,
                'GET_ATLAS_PARAMETRO_GENERAL': JSON.parse(data.GET_ATLAS_PARAMETRO_GENERAL).Recordset0.Rows,
                'GET_CARTERAS_PRODUCTO': JSON.parse(data.GET_CARTERAS_PRODUCTO).Recordset0.Rows,
                'GET_MODELO_LIQUIDACION_PRODUCTO': JSON.parse(data.GET_MODELO_LIQUIDACION_PRODUCTO).Recordset0.Rows,
                'GET_ATLAS_CATEGORIA_CAJERO_PRODUCTO': JSON.parse(data.GET_ATLAS_CATEGORIA_CAJERO_PRODUCTO).Recordset0.Rows,
                'GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID': JSON.parse(data.GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID).Recordset0.Rows,
                'GET_PRODUCTO_FORMA_DEBITO_PRODUCTO_ID': JSON.parse(data.GET_PRODUCTO_FORMA_DEBITO_PRODUCTO_ID).Recordset0.Rows,
                'GET_SUCURSAL_CLIENTE_CUENTA': JSON.parse(data.GET_SUCURSAL_CLIENTE_CUENTA_CABAL).Recordset0.Rows,
                'GET_HABILITACION_CAJERO_PRODUCTO': JSON.parse(data.GET_HABILITACION_CAJERO_PRODUCTO).Recordset0.Rows,
                'GET_ATLAS_MONEDA': JSON.parse(data.GET_ATLAS_MONEDA).Recordset0.Rows,
                'GET_ATLAS_ENTIDAD_BANCARIA': JSON.parse(data.GET_ATLAS_ENTIDAD_BANCARIA).Recordset0.Rows,
                'GET_ATLAS_TIPO_CUENTA_BANCARIA': JSON.parse(data.GET_ATLAS_TIPO_CUENTA_BANCARIA).Recordset0.Rows,
                'GET_TARJETA_TIPO_BY_CUENTA_TIPO': JSON.parse(data.GET_TARJETA_TIPO_BY_CUENTA_TIPO).Recordset0.Rows,
                'GET_ATLAS_LIMITE_COMPRA': JSON.parse(data.GET_ATLAS_LIMITE_COMPRA).Recordset0.Rows,
                'GET_PRODUCTO_CABAL_PRODUCTO_ID': JSON.parse(data.GET_PRODUCTO_CABAL_PRODUCTO_ID).Recordset0.Rows[0],
                'GET_PRODUCTO_DEFAULT_CABAL_PRODUCTO': JSON.parse(data.GET_PRODUCTO_DEFAULT_CABAL_PRODUCTO).Recordset0.Rows[0],
                'GET_SEGMENTO_CARTERA_PRODUCTO_ID': JSON.parse(data.GET_SEGMENTO_CARTERA_PRODUCTO_ID).Recordset0.Rows,
                'GET_MARCA_COMPARTIDA_PRODUCTO_ID': JSON.parse(data.GET_MARCA_COMPARTIDA_PRODUCTO_ID).Recordset0.Rows,
                'ATLAS_GRUPO_AFINIDAD': JSON.parse(data.GET_GRUPOS_AFINIDAD_BY_PRODUCTO).Recordset0.Rows,
                'productoId': productoId,
                'GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA': JSON.parse(data.GET_ATLAS_CUENTA_TIPO_BY_ADMINISTRADORA).Recordset0.Rows.filter(c => c.Id == cuentaTipo),
                'GET_EQUIVALENCIA_ATLAS_TIPO_DOCUMENTO_CODIGO': JSON.parse(data.GET_EQUIVALENCIA_ATLAS_TIPO_DOCUMENTO_CODIGO).Recordset0.Rows
            }
            break
            
        }
        default:
    }
        
    _dispatch({ type: GET_DATA_SOLICITUD_RESULT, result: result, productoId: productoId });
    _dispatch({ type: SAVE_SOLICITUD_CUENTA_SELECCION, prop: "datosProductoSeleccionado", value: result });
    _dispatch({ type: SAVE_SOLICITUD_CUENTA_SELECCION, prop: "cargaDatosPantallaAdicionales", value: result });
    _dispatch({ type: RETRIEVING_DATA, payload: false });
}

/**
 * 
 * @param {any} data
 */
function _loadValidateCuenta(data, state) {
    
    LogHelper.In(_loadValidateCuenta.name, data);
    if (!Array.isArray) {
        Array.isArray = function (arg) {
            return Object.prototype.toString.call(arg) === '[object Array]';
        };
    }

    function validarValor(campo){
       return !([null, 0, "","empty"].some(s => s == campo));
    }

    let marca = _tarjetas.administradora.Id ? _tarjetas.administradora.Id : _tarjetas.administradora;
    let parametrosGenerales = data.GET_ATLAS_PARAMETRO_GENERAL;
    let productoVisa = marca == 1 ? data.GET_PRODUCTO_VISA_PRODUCTO_ID : null;
    let productoCabal = marca == 2 ?data.GET_PRODUCTO_CABAL_PRODUCTO_ID: null;
    let fieldsToValidate;

    switch (marca) {
        case 1:
            fieldsToValidate = [
                { type: "email", valid: "email", hasCondition: true },
                { type: "emailFormato", valid: "emailFormato", hasCondition: true },
                { type: "comDomicilioSeleccionadoId", valid: "comDomicilioSeleccionadoId", hasCondition: true },
                { type: "comCodGeogId", valid: "comCodGeogId", hasCondition: true },
                { type: "comTipo", valid: "comTipo", hasCondition: true },
                { type: "GET_CARTERAS_EMPRESA", valid: "carteraId", hasCondition: true },
                { type: "GET_MODELO_LIQUIDACION_PRODUCTO", valid: "modeloLiquidacionId", hasCondition: true },
                { type: "LIMITE_FINANCIACION", valid: "limiteFinanciacion", hasCondition: true },
                { type: "GET_ATLAS_CATEGORIA_CAJERO_PRODUCTO", valid: "categoriaCajerosId", hasCondition: true },
                { type: "GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID", valid: "formaPagoId"},
                { type: "GET_PRODUCTO_FORMA_DEBITO_PRODUCTO_ID", valid: "formaDebitoId", hasCondition: true },
                { type: "SUCURSA_PESOS", valid: "sucursalCuentaPesosId", hasCondition: true },
                { type: "CUENTA_PESOS", valid: "cuentaPesosId", hasCondition: true },
                { type: "SUCURSA_DOLARES", valid: "sucursalCuentaDolaresId", hasCondition: true },
                { type: "CUENTA_DOLARES", valid: "cuentaDolaresId", hasCondition: true },
                { type: "GET_MODALIDAD_DISTRIBUCION_LIMITE_PRODUCTO_ID", valid: "modeloDistribucionId" },
                { type: "GET_LIMITE_COMPRA_PRODUCTO", valid: "limiteCompraId", hasCondition: true },
                { type: "limiteCompraInput", valid: "limiteCompra", hasCondition: true },
                { type: "FACTOR_LIMITE_COMPRA", valid: "factorLimiteCompra", hasCondition: true },
                { type: "GET_LINEA_PRESTAMO_PRODUCTO", valid: "limitePrestamoId", hasCondition: true },
                { type: "ATLAS_SUCURSALES", valid: "sucursalSeleccionadaId" },
                { type: "PRODUCTO", valid: "productoId" },
                { type: "denominacionCuenta", valid: "denominacionCuenta" },
                { type: "descripcionCuenta", valid: "descripcionCuenta" },
                { type: "ATLAS_GRUPO_AFINIDAD", valid: "grupoAfinidadSeleccionadoId", hasCondition: true },
                { type: "ATLAS_DISTRIBUCION", valid: "codigoDistribucionSeleccionadoId", hasCondition: true },
                { type: "ATLAS_COMERCIALIZADORA", valid: "comercializadoraSeleccionadaId", hasCondition: true },
                { type: "SELECCIONO_CUOTAS_COSTO_EMISION", valid:"cuotasCostoEmision", hasCondition:true },
                { type: "SELECCIONO_PORCENTAJE_COSTO_EMISION", valid:"porcentajeCostoEmision", hasCondition:true },
                //{ type: "denominacion_titular", valid:"denominacionTarjetaTitular", hasCondition:true },
                { type: "GET_SUBTIPO_CUENTA", valid:"subTipoCuentaSeleccionadaId", hasCondition:true },
                { type: "denominacionCuartaLinea", valid:"denominacionCuartaLinea", hasCondition:true }
            ];
            break;
        case 2:
            fieldsToValidate = [
                { type: "limiteCompraInput", valid: "limiteCompra", hasCondition: true },
                { type: "LIMITE_COMPRA_RADIO", valid: "monedaSelected", hasCondition: true },
                { type: "ATLAS_SUCURSALES", valid: "sucursalSeleccionadaId", hasCondition: true },
                { type: "PRODUCTO", valid: "productoId", hasCondition: true },
                { type: "ATLAS_GRUPO_AFINIDAD", valid: "grupoAfinidadSeleccionadoId", hasCondition: true },
                { type: "ATLAS_SEGMENTO_CARTERA", valid: "segmentoCarteraSeleccionadoId", hasCondition: true },
                { type: "ATLAS_MARCA_COMPARTIDA", valid: "marcaCompartidaSeleccionadaId", hasCondition: true },
                { type: "comDomicilioSeleccionadoId", valid: "comDomicilioSeleccionadoId", hasCondition: true },
                { type: "comTipo", valid: "comTipo", hasCondition: true },
                { type: "email", valid: "email", hasCondition: true },
                { type: "emailFormato", valid: "emailFormato", hasCondition: true },
                { type: "cuartaLinea", valid: "cuartaLinea", hasCondition: true },
                { type: "preEmision", valid: "preEmision", hasCondition: true },
                { type: "altaPosData", valid: "altaPosData", hasCondition: true },
                { type: "retencionTarjetas", valid: "retencionTarjetas", hasCondition: true },
                { type:"limiteFinanciacion", valid: "seleccionoLimiteFinanciacion", hasCondition:true},
                { type:"topePagoMinimo", valid: "seleccionoTopePagoMinimo", hasCondition: true},
                { type:"carteraId", valid: "carteraId"},
                { type: "FACTOR_LIMITE_COMPRA", valid: "factorLimiteCompra", hasCondition: true },
                { type: "denominacionCuartaLinea", valid:"denominacionCuartaLinea", hasCondition:true }
            ];
            break;

        default:
    }
    
    const valids = [];
    if(data.GET_PRODUCTO_CABAL_PRODUCTO_ID && data.GET_PRODUCTO_CABAL_PRODUCTO_ID.Id  ||data.GET_PRODUCTO_VISA_PRODUCTO_ID && data.GET_PRODUCTO_VISA_PRODUCTO_ID.Id){
        //PARA EVITAR ERRORES POR NO EXISTIR PRODUCTO, LO PRIMERO QUE SE VALIDA ES QUE EXISTA PRODUCTO SELECCIONADO, YA SEA CABAL O VISA
        fieldsToValidate.forEach(f => {
        let result = false;
            
        if (f.hasCondition) {
            switch (f.type) {
                case "denominacionCuartaLinea":{
                    if(data.denominacionCuartaLinea){
                        result = data.denominacionCuartaLinea.length < 20
                    }else{
                        result = true
                    }
                    break;
                }
                case "GET_SUBTIPO_CUENTA":{

                    if(data.GET_SUBTIPO_CUENTA && data.GET_SUBTIPO_CUENTA.length>0){
                        let permiteNuevosAtributos = productoVisa.NuevosAtributos
                        if(!permiteNuevosAtributos && !data.GET_SUBTIPO_CUENTA.some(sub=>sub.CodigoSubtipoCuenta!="NA")){
                            result=true
                        }else{
                            result = !([null, 0, "",undefined].some(s => s === data.subTipoCuentaSeleccionadaId));
                        }
                    }else{
                        result = true
                    }
                    break;
                }
                case "carteraId":{
                        result = data.carteraId > 0
                    break;
                }
                case "limiteFinanciacion":{
                    let limiteDesde = parseInt(productoCabal.LimiteFinanciacionDesde);
                    let limiteHasta = parseInt(productoCabal.LimiteFinanciacionHasta);

                    result = (data.limiteFinanciacion   && parseInt(data.limiteFinanciacion) >= limiteDesde && parseInt(data.limiteFinanciacion) <= limiteHasta)

                    break;
                }
                case "denominacion_titular":{
                    let nombre = data.denominacion1 ? data.denominacion1 : "";
                    let apellido = data.denominacion2 ? data.denominacion2 : "";
                    
                    let regExp = new RegExp(/^[a-záéíóúñÑA-Z\.]*$/);
                    let largo = nombre.length + apellido.length;

                    if(state.tarjetas.tipoEmpresa.EmpresaIndividuos =="I"){
                        if (regExp.test(nombre) && regExp.test(apellido) && nombre[0] !== "." && nombre !=="" &&  apellido!=="" && apellido[0] !=="." && largo < 19) {
                            result = true;
                        }else{
                            result = false;
                        }
                    }else{
                        result = true;
                    }

                    break;
                }
                case "topePagoMinimo":{
                    if(productoCabal && productoCabal.TopePagoMinimoXCuenta){
                        let topeDesde = parseInt(productoCabal.TopePagoMinimoDesde);
                        let topeHasta = parseInt(productoCabal.TopePagoMinimoHasta);

                        result = (data.topePagoMinimo && parseInt(data.topePagoMinimo) >= topeDesde && parseInt(data.topePagoMinimo) <= topeHasta)

                    }else{
                        result = true
                    }
                    
                    break;
                }
                case "telefonoSeleccionado": {
                    let celular = !([null, 0, ""].some(s => s === data.telefonoSeleccionado));
                    let fijo = !([null, 0, ""].some(s => s === data.celularSeleccionado));
                    
                    if(!celular && !fijo){
                        result = false
                    }else{
                        result = true
                    }
                    break;
                }
                case "comDomicilioSeleccionadoId": {
                    if(data.comDomicilioPostal){
                        result = !([null, 0, ""].some(s => s === data[f.type]));
                    }else{
                        result = true
                    }
                    break;
                }
                case "comCodGeogId": {
                    if(data.comDomicilioPostal){
                        result = !([null, 0, ""].some(s => s === data[f.type]));
                    }else{
                        result = true
                    }
                    break;
                }
                case "emailFormato": {
                    if(data.email){
                        let valor = data.email
                        let valida = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(valor)
                        result = valida
                    }else{
                        result = true
                    }
                    break;
                }
                case "email":{
                    if(data.comEmail){
                        if(data.email && data.email != ""){
                            result = true
                        }else{
                            result = false
                        }

                    }else{
                        result= true
                    }
                    break;
                }
                case "comTipo": {
                    result = (data.comEmail == false && data.comDomicilioPostal == true) || (data.comEmail == true && data.comDomicilioPostal == false)
                    break;
                }
                case "limiteCompraInput":{
                    if(data.GET_PRODUCTO_VISA_PRODUCTO_ID && data.GET_PRODUCTO_VISA_PRODUCTO_ID.LimiteCompraMaximo){

                        result = parseInt(data.limiteCompra) > 0 && parseInt(data.limiteCompra) <= parseInt(data.GET_PRODUCTO_VISA_PRODUCTO_ID.LimiteCompraMaximo)  
                    
                    }else if(data.GET_PRODUCTO_CABAL_PRODUCTO_ID ){

                        let productoElegido = data.GET_PRODUCTO_CABAL_PRODUCTO_ID

                        result = (data.limiteCompra && parseInt(data.limiteCompra) >= parseInt(productoElegido.LimiteCompraDesde) && parseInt(data.limiteCompra) <= parseInt(productoElegido.LimiteCompraHasta));  

                    }else{
                        result = true
                    }
                    break;
                }
                case "GET_LIMITE_COMPRA_PRODUCTO":{
                    if(!data.GET_PRODUCTO_VISA_PRODUCTO_ID.LimiteCompraMaximo){
                        result = validarValor(data[f.valid]) 
                    }else{
                        result = true
                    }
                    break;
                }
               
                case "GET_CARTERAS_EMPRESA":
                case "GET_MODELO_LIQUIDACION_PRODUCTO":
                case "GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID":
                case "GET_MODALIDAD_DISTRIBUCION_LIMITE_PRODUCTO_ID":
                case "GET_SUCURSAL_CLIENTE_CUENTA":
                case "ATLAS_SUCURSALES":
                case "PRODUCTO":
                case "ATLAS_TIPO_CUENTA":{
                    if (data[f.valid] && data[f.valid] != "0")
                    result = true;
                    else
                    result = false;
                    break;
                }
                case "preEmision":{
                    let productoElegido

                    if(data.GET_PRODUCTO_CABAL_PRODUCTO_ID){
                        productoElegido = data.GET_PRODUCTO_CABAL_PRODUCTO_ID
                    }
                    if(productoElegido && productoElegido.PreEmision){ //TODO descomentar
                       result= data.preEmisionId != undefined
                    }else{
                        result = true;
                    }

                    break;
                }
                case "altaPosData":{
                    let productoElegido

                    if(data.GET_PRODUCTO_CABAL_PRODUCTO_ID){
                        productoElegido = data.GET_PRODUCTO_CABAL_PRODUCTO_ID
                    }
                    if(productoElegido && productoElegido.AltaPosDatada){
                        result= data.altaPosDatadaId != undefined
                    }else{
                        result = true;
                    }

                    break;
                }
                case "retencionTarjetas":{
                    let productoElegido

                    if(data.GET_PRODUCTO_CABAL_PRODUCTO_ID){
                        productoElegido = data.GET_PRODUCTO_CABAL_PRODUCTO_ID
                    }
                    if(productoElegido && productoElegido.RetencionTarjeta){
                        result= data.retencionTarjetaId != undefined
                    }else{
                        result = true;
                    }

                    break;
                }
                case "ATLAS_COMERCIALIZADORA": {
                    if (data.HabilitaComercializadora){
                        if (data[f.valid] && data[f.valid] != "0")
                        result = true;
                        else
                        result = false;
                    }else{
                        result = true;
                    }
                    break;
                }
                case "ATLAS_GRUPO_AFINIDAD": {

                    let productoElegido

                    if(data.GET_PRODUCTO_VISA_PRODUCTO_ID){
                        productoElegido = data.GET_PRODUCTO_VISA_PRODUCTO_ID
                    }else if(data.GET_PRODUCTO_CABAL_PRODUCTO_ID){
                        productoElegido = data.GET_PRODUCTO_CABAL_PRODUCTO_ID
                    }

                    if (productoElegido && productoElegido.AsociaGrupoAfinidad){
                        if (data[f.valid] && data[f.valid] != "0")
                        result = true;
                        else
                        result = false;
                    }else{
                        result = true;
                    }
                    break;
                }
                case "ATLAS_DISTRIBUCION": {
                    if (data.UtilizaCodigoDistribucion){
                        if (data[f.valid] && data[f.valid] != "0")
                        result = true;
                        else
                        result = false;
                    }else{
                        result = true;
                    }
                    break;
                }
                case "ATLAS_SEGMENTO_CARTERA": {

                    let productoElegido

                    if(data.GET_PRODUCTO_CABAL_PRODUCTO_ID){
                        productoElegido = data.GET_PRODUCTO_CABAL_PRODUCTO_ID
                    }

                    if (productoElegido.AsociaSegmentoCartera && data.GET_ATLAS_PARAMETRO_GENERAL.SINOSEGMENTOSCARTERA){
                        if (data[f.valid] && data[f.valid] != "0")
                        result = true;
                        else
                        result = false;
                    }else{
                        result = true;
                    }
                    break;
                }
                case "ATLAS_MARCA_COMPARTIDA": {
                    let productoElegido

                    if(data.GET_PRODUCTO_CABAL_PRODUCTO_ID){
                        productoElegido = data.GET_PRODUCTO_CABAL_PRODUCTO_ID
                    }

                    if (productoElegido.AsociaMarcaCompartida){
                        if (data[f.valid] && data[f.valid] != "0")
                        result = true;
                        else
                        result = false;
                    }else{
                        result = true;
                    }
                    break;
                }
                case "LIMITE_FINANCIACION": {

                    if ((parametrosGenerales.SINOLIMITEFINANCIACIONCUENTA && productoVisa && productoVisa.LimiteFinanciacionxCuenta) && data.limiteFinanciacion) {

                        if (data.limiteFinanciacion >= productoVisa.LimiteFinanciacionDesde && data.limiteFinanciacion <= productoVisa.LimiteFinanciacionHasta)
                            result = true;
                        else result = false;
                    }
                    else if (parametrosGenerales.SINOLIMITEFINANCIACIONCUENTA && productoVisa && productoVisa.LimiteFinanciacionxCuenta)
                        result = false;
                    else
                        result = true;

                    break;
                }
                case "GET_ATLAS_CATEGORIA_CAJERO_PRODUCTO": {
                    if (parametrosGenerales.SINOREDBANELCO && data.categoriaCajerosId)
                        result = true;
                    else if (parametrosGenerales.SINOREDBANELCO)
                        result = false;
                    else
                        result = true;

                    break;
                }
                case "GET_PRODUCTO_FORMA_DEBITO_PRODUCTO_ID": {

                    var formaPago = data.GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID.filter(formasDePago => formasDePago.FormaPagoId == data.formaPagoId);

                    if (formaPago && formaPago.length > 0 && formaPago[0].EsDebitoEnCuenta && data.formaDebitoId)
                        result = true;
                    else if (formaPago && formaPago.length > 0 && formaPago[0].EsDebitoEnCuenta)
                        result = false;
                    else
                        result = true;

                    break;
                }
                case "SUCURSA_PESOS": {

                    var formaPago = data.GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID.filter(formasDePago => formasDePago.FormaPagoId == data.formaPagoId);

                    if (formaPago && formaPago.length > 0 && formaPago[0].EsDebitoEnCuenta) {

                        if ((data.sucursalCuentaPesosId && data.sucursalCuentaPesosId != "0" && (!data.cuentaPesosId || data.cuentaPesosId == "0")) ||
                            ((!data.sucursalCuentaPesosId || data.sucursalCuentaPesosId == "0") && data.cuentaPesosId && data.cuentaPesosId != "0"))
                            result = false;
                        else
                            result = true;
                    } else
                        result = true;

                    break;
                }
                case "CUENTA_PESOS": {

                    var formaPago = data.GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID.filter(formasDePago => formasDePago.FormaPagoId == data.formaPagoId);

                    if (formaPago && formaPago.length > 0 && formaPago[0].EsDebitoEnCuenta) {

                        if ((data.sucursalCuentaPesosId && data.sucursalCuentaPesosId != "0" && (!data.cuentaPesosId || data.cuentaPesosId == "0")) ||
                            ((!data.sucursalCuentaPesosId || data.sucursalCuentaPesosId == "0") && data.cuentaPesosId && data.cuentaPesosId != "0"))
                            result = false;
                        else
                            result = true;
                    } else
                        result = true;

                    break;
                }
                case "SUCURSA_DOLARES": {

                    var formaPago = data.GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID.filter(formasDePago => formasDePago.FormaPagoId == data.formaPagoId);

                    if (formaPago && formaPago.length > 0 && formaPago[0].EsDebitoEnCuenta) {

                        if ((data.sucursalCuentaDolaresId && data.sucursalCuentaDolaresId != "0" && (!data.cuentaDolaresId || data.cuentaDolaresId == "0")) ||
                            ((!data.sucursalCuentaDolaresId || data.sucursalCuentaDolaresId == "0") && data.cuentaDolaresId && data.cuentaDolaresId != "0"))
                            result = false;
                        else
                            result = true;
                    } else
                        result = true;

                    break;
                }
                case "CUENTA_DOLARES": {

                    var formaPago = data.GET_PRODUCTO_FORMA_PAGO_PRODUCTO_ID.filter(formasDePago => formasDePago.FormaPagoId == data.formaPagoId);

                    if (formaPago && formaPago.length > 0 && formaPago[0].EsDebitoEnCuenta) {

                        if ((data.sucursalCuentaDolaresId && data.sucursalCuentaDolaresId != "0" && (!data.cuentaDolaresId || data.cuentaDolaresId == "0")) ||
                            ((!data.sucursalCuentaDolaresId || data.sucursalCuentaDolaresId == "0") && data.cuentaDolaresId && data.cuentaDolaresId != "0"))
                            result = false;
                        else
                            result = true;
                    } else
                        result = true;

                    break;
                }
                case "CUENTA_SELECCIONADA": {

                    if ((!data.cuentaDolaresId || data.cuentaDolaresId == "0") && (!data.cuentaPesosId || data.cuentaPesosId == "0"))
                        result = false;
                    else
                        result = true;

                    break;
                }
                case "LIMITE_COMPRA_RADIO": {

                    if (data.pesos || data.dolares || !data.GET_PRODUCTO_VISA_PRODUCTO_ID)
                        result = true;
                    else
                        result = false;

                    break;
                }

                case "FACTOR_LIMITE_COMPRA": {
                    
                    if (productoVisa && productoVisa.FLCCxCuenta) {

                        if (parseFloat(data.factorLimiteCompra) >= productoVisa.FLCCDesde && parseFloat(data.factorLimiteCompra) <= productoVisa.FLCCHasta)
                            result = true;
                        else
                            result = false;

                    }else if(productoCabal){
                        
                        result = (data.CLCC && parseFloat(data.CLCC) >= parseFloat(productoCabal.CLCCDesde) && parseFloat(data.CLCC) <= parseFloat(productoCabal.CLCCHasta) )
                    
                    }else{
                        result = true;
                    }
                    
                    break;
                }

                case "GET_LINEA_PRESTAMO_PRODUCTO": {

                    if (parametrosGenerales.SINOLINEAPRESTAMOS && data.GET_LINEA_PRESTAMO_PRODUCTO.length>0) {

                        if (data.limitePrestamoId)
                            result = true;
                        else
                            result = false;

                    } else
                        result = true;
                    break;
                }
                case "SELECCIONO_CUOTAS_COSTO_EMISION":{
                    if(data.GET_PRODUCTO_VISA_PRODUCTO_ID && data.GET_PRODUCTO_VISA_PRODUCTO_ID.CargoEnCuotas && data.GET_PRODUCTO_VISA_PRODUCTO_ID.CostoEmision!=="SC"){ //si el costo de emision es distinto a "SIN CARGO", verifica que se haya agregado un costo
                    if(data.cuotasCostoEmisionSeleccionadas){
                        if( parseInt(data.cuotasCostoEmisionSeleccionadas)>data.GET_PRODUCTO_VISA_PRODUCTO_ID.CargoEnCuotasHasta || parseInt(data.cuotasCostoEmisionSeleccionadas) < data.GET_PRODUCTO_VISA_PRODUCTO_ID.CargoEnCuotasDesde){
                            result= false
                        }
                        else{
                            result = true
                        }
                    }
                    else 
                    result = false
                }
                else{
                    result=true
                }
                    break;
                }
                case "SELECCIONO_PORCENTAJE_COSTO_EMISION":{
                        if(data.GET_PRODUCTO_VISA_PRODUCTO_ID && data.GET_PRODUCTO_VISA_PRODUCTO_ID.CostoEmision=="BP"){
                                if(data.porcentajeCostoEmision){
                                    if(parseInt(data.porcentajeCostoEmision)>parseInt(data.GET_PRODUCTO_VISA_PRODUCTO_ID.PorcBonificacionEmisionHasta)||parseInt(data.porcentajeCostoEmision)<parseInt(data.GET_PRODUCTO_VISA_PRODUCTO_ID.PorcBonificacionEmisionDesde)){
                                        result =false
                                    }
                                else{
                                    result =true
                                    }
                                }
                                else{
                                    result= false
                                }
                        }
                        else {
                            result=true
                        }
                    break;
                }
                case "GET_TARJETA_TIPO_BY_CUENTA_TIPO":

                    if (data.GET_TARJETA_TIPO_BY_CUENTA_TIPO && data.GET_TARJETA_TIPO_BY_CUENTA_TIPO.TarjetaTipoId)
                        result = true;
                    else
                        result = false;

                    break;
                case "cuartaLinea": {

                    if (!data.cuartaLinea || data.cuartaLinea <= 19)
                        result = true;
                    else
                        result = false;

                    break;
                }
            }
        }else{
            result = validarValor(data[f.valid])
        }

        data.ERROR_CUENTA[f.valid] = result
        valids.push(result);
    });
    }else{
        //SI NO SE SELECCIONÓ PRODUCTO SE PONEN EN FALSE LAS VALIDACIONES DE TODOS LOS CAMPOS, SALVO SUCURSAL QUE SE DEBE CHECKEAR SI SE SELECCIONÓ
        if(data.sucursalSeleccionadaId){
            fieldsToValidate.forEach(campo=>{
                //if(campo.valid !=sucursalSeleccionadaId){
                //    data.ERROR_CUENTA[campo.valid] = false
                //    valids.push(false)
                    
                //}else{
                //    data.ERROR_CUENTA[campo.valid] = true
                //    valids.push(true)
                //}
            })  
        }else{
            fieldsToValidate.forEach(campo=>{
                data.ERROR_CUENTA[campo.valid] = false
                valids.push(false)
                
            })  
        } 
    }
    const validate = !valids.some(v => v == false);
    
    if(validate){
        
        data.administradoraId = _tarjetas.administradora.Id;
        data.tipoEmpresa = _tarjetas.tipoEmpresa;
        data.cliente = state.tarjetas.clienteResultadoBusqueda;
        data.empresa = state.tarjetas.empresaVisaSeleccionada;
        data.Empresa = _tarjetas.empresaVisaSeleccionada ? _tarjetas.empresaVisaSeleccionada : null ;
        
        
        if (_tarjetas.esModificacion) {
            let tarjetasNew = state.tarjetas;

            if (_tarjetas.solicitudCuenta.GET_PRODUCTO_VISA_PRODUCTO_ID) {
                data.SolicitudEstadoId = _tarjetas.solicitudCuenta.GET_PRODUCTO_VISA_PRODUCTO_ID.SolicitudEstadoId; 
            }

            if (_tarjetas.solicitudCuenta.ProductoCabalSeleccionado) {
                data.SolicitudEstadoId = _tarjetas.solicitudCuenta.ProductoCabalSeleccionado.SolicitudEstadoId; 
            }
            
            data.adicionalesEliminados =  tarjetasNew.adicionalesEliminados.length>0 ? tarjetasNew.adicionalesEliminados : [] ;

            //SI SE ELIMINA UN ADICIONAL Y SE LO VUELVE A DAR DE ALTA SE CONSERVA EL GUARDADO EN BASE DE DATOS, MODIFICANDOLO CON LOS DATOS NUEVOS
            if(data.adicionalesEliminados.length>0 && data.cuentasAdicionales.length>0){
                let arrayAuxiliarAdicionales=[];

                data.adicionalesEliminados.map(adicional=>{
                    let flag=false;
                    data.cuentasAdicionales.map(adic=>{
                        if(adic.ClienteTarjetas.Cuit==adicional.ClienteTarjetas.Cuit){
                            flag=true;
                            adic.IdAdicional= adicional.IdAdicional;
                            adic.TarjetaCreditoCabalId= adicional.TarjetaCreditoCabalId;
                            adic.TarjetaCreditoVisaId= adicional.TarjetaCreditoVisaId;
                            adic.ClienteTarjetas= JSON.parse(JSON.stringify(adicional.ClienteTarjetas));
                        }
                    })
                    if(!flag) arrayAuxiliarAdicionales.push(JSON.parse(JSON.stringify(adicional)))
                })

                data.adicionalesEliminados = JSON.parse(JSON.stringify(arrayAuxiliarAdicionales))
            }

            data.SolicitudId = _tarjetas.datosSolicitud.tarjetasSolicitud[0].SolicitudId;
            data.TarjetaCreditoId = _tarjetas.datosSolicitud.tarjetasSolicitud[0].TarjetaCreditoId;
            data.TarjetaCreditoVisaId = _tarjetas.datosSolicitud.tarjetasSolicitud[0].TarjetaCreditoVisaId;
            data.TarjetaCreditoCabalId = _tarjetas.datosSolicitud.tarjetasSolicitud[0].TarjetaCreditoCabalId;

            data.CuentaTarjetaId = _tarjetas.datosSolicitud.CuentaTarjetaId; 
            data.CuentaTarjetaVisaId = _tarjetas.datosSolicitud.CuentaTarjetaVisaId; 
            data.DatosSolicitud = _tarjetas.datosSolicitud;

            data.SolicitudCuenta = _tarjetas.solicitudCuenta;
            
            SolicitudManager.ModificarSolicitud(JSON.parse(JSON.stringify(data)), SagasHelper.GetSagasId, ejecutarPorEstado, _executionContext);
        } else {
            SolicitudManager.GuardarSolicitud(JSON.parse(JSON.stringify(data)), SagasHelper.GetSagasId, ejecutarPorEstado, _executionContext);
        }
        
        _dispatch({ type: READY_REQUEST_CUENTA });
        
    } else {
        _dispatch({ type: VALIDATE_CUENTA_ERROR_CUENTA, error: data.ERROR_CUENTA });
    }
    
}

/**
 * 
 * @param {any} result
 * @param {any} disconectCallback
 */
function ejecutarPorEstado(result, disconectCallback) {
    LogHelper.In(ejecutarPorEstado.name, result, disconectCallback);

    let type;
    let modalId;
        
    switch (result.Estado) {
        case 2: 
            _dispatch({ type: ROUTE_TO_VISTACLIENTE_FROM_CUENTA});
            modalId = "solicitudGuardada";
            $("#" + modalId).modal();
            disconectCallback();
            break;
        case 3:
            HandleErrorSaga();
            disconectCallback();
            break;
    }
}

/**
 * 
 */
function HandleErrorSaga() {
    let message = {
        value: "Hubo un error al procesar la transacci\u00F3n.",
        class: "error"
    };

    _dispatch({ type: SHOW_SAVE_STATUS_NUEVA_SOLICITUD_CUENTA, message });
}

/**
 * Obtiene los parametros del Web Service del Banco
 * @param {any} documento
 */
function getParametrosWs(documento) {
    LogHelper.In(getParametrosWs.name, documento);

    let valorParseado = parseInt(documento);
    let valorString = valorParseado.toString();

    return param = {
        'NRO_DOCUMENTO': valorParseado,
        'PAIS_DOCUMENTO': "80"
    }
}

////////////////////////LLAMADO WEB SERVICE //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 * Búsqueda de Cliente Lista Documentos
 * @param {any} value
 */
function _buscarClienteListaDocumentos(value) {
    LogHelper.In(_buscarClienteListaDocumentos.name, value);

    //TODO: colocar los parametros correspondientes
    let parametroClienteListaDocumentos = {
        'PAIS_DOCUMENTO': '80',
        'NRO_DOCUMENTO': value
    }

    LogHelper.Out(_buscarClienteListaDocumentos.name, parametroClienteListaDocumentos, 'GETCLIENTELISTADOCUMENTOS', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');
    Engine1Proxy.AddRuleRequests(parametroClienteListaDocumentos, 'GETCLIENTELISTADOCUMENTOS', 'Tarjetas', 'CONSULTASOCIOS', 'Socios');

    Engine1Proxy.Execute(_callBackBuscarClienteListaDocumentos, null, null, "CONSULTASOCIOS");
}

/**
 * Call Back que recibe los Datos de Cliente Lista Documentos atravez de la rule
 * @param {any} data
 */
function _callBackBuscarClienteListaDocumentos(data) {
    LogHelper.In(_callBackBuscarClienteListaDocumentos.name, data);

    if (data.GETCLIENTELISTADOCUMENTOS != "null") {
        let clienteDatosFiliatorios = JSON.parse(data.GETCLIENTELISTADOCUMENTOS);
        _dispatch({ type: FOUND_CLIENTE_LISTA_DOCUMENTOS });

    } else {
        _dispatch({ type: NOT_FOUND_CLIENTE_LISTA_DOCUMENTOS });
    }
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////